
<template>
  <div class="flex flex-wrap md:flex-nowrap gap-1 font-sans items-start">

    <!-- LEFT SIDE -->
    <div :class="showWaiterOrderCards ? 'w-full' : 'w-full md:w-2/3'">
      <div class="flex flex-col space-y-3 bg-white rounded-lg shadow-lg p-4">

        <!-- Waiter My Orders cards (replaces dept/menu area) -->
        <template v-if="showWaiterOrderCards">
          <div class="flex items-center space-x-1">
            <button
              type="button"
              @click="resetWaiterOrderCardsLeftSide"
              class="px-2 py-1 text-[12px] border border-gray-300 rounded-sm flex-shrink-0 font-semibold shadow-sm transition-all bg-white text-gray-700 hover:bg-gray-100"
            >
              Back
            </button>
          </div>
          <div class="grid gap-3 grid-cols-1 md:grid-cols-3">
            <div
              v-for="order in waiterMyOrderCards"
              :key="order.id"
              class="border border-gray-200 rounded-lg bg-white shadow-lg overflow-hidden flex flex-col"
            >
              <div :class="[isBeforeTodayOrderCard(order) ? 'bg-red-600' : 'bg-[#0d4169]', 'text-white flex flex-wrap items-center justify-between gap-1 px-3 py-2 text-[11px]']">
                <span class="font-bold text-white">Table: {{ String(order.table).length <= 5 ? (order.table || '---') : '---' }}</span>
                <span class="font-semibold text-white">O. No: {{ order.dailyOrderNo ?? '---' }}</span>
                <span class="text-white">{{ formatWaiterOrderCardDate(order.createdAt) }}</span>
                <span class="font-semibold capitalize text-white">{{ order.waiterName || '---' }}</span>
              </div>

              <div class="p-3 flex flex-col flex-1">
              <div class="grid grid-cols-[minmax(0,1fr)_2.25rem_3.25rem_3.25rem_0.875rem] gap-x-1 items-center justify-items-stretch font-bold text-[11px] text-gray-700">
                <span class="text-left">Name</span>
                <span class="text-right">Qty</span>
                <span class="text-right">U.P</span>
                <span class="text-right">T.P</span>
                <span></span>
              </div>

              <div class="space-y-0.5">
              <div
                v-for="(item, idx) in getWaiterOrderCardItems(order)"
                :key="item.localId || idx"
                class="grid grid-cols-[minmax(0,1fr)_2.25rem_3.25rem_3.25rem_0.875rem] gap-x-1 items-center justify-items-stretch py-0.5 font-bold text-[11px] text-gray-700 border-b border-gray-100 last:border-b-0 px-0.5 rounded-sm"
                :class="{ 'bg-green-100/70 border-green-300': item.hasAcceptedTransfer }"
              >
                  <span class="waiter-card-item-name">{{ item.name }}</span>
                  <span class="text-right tabular-nums">{{ item.qty }}</span>
                  <span class="text-right tabular-nums">
                    {{ Number(item.unitPrice || 0).toFixed(1) }}
                  </span>
                  <span class="text-right tabular-nums">
                    {{ (Number(item.qty || 0) * Number(item.unitPrice || 0)).toFixed(1) }}
                  </span>
                  <span class="flex items-center justify-center">
                    <svg
                      v-if="item.hasPendingTransfer"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#0d4169"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="inline-block"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </span>
              </div>
              </div>

              <div v-if="getWaiterOrderCardItems(order).length === 0" class="text-gray-500 text-sm italic py-2">
                No items.
              </div>

              <div class="mt-2 mb-2 text-right">
                <div class="pt-2 pr-1 border-t border-gray-100 text-right space-y-0.5 text-[11px]">
                  <div>
                    <span class="text-gray-600">Base Amt:</span>
                    <span class="font-semibold text-gray-700 ml-1">{{ getWaiterOrderCardAmounts(order).baseAmt }} </span>
                  </div>
                  <div>
                    <span class="text-gray-600">Additional Amt:</span>
                    <span class="font-semibold text-gray-700 ml-1">{{ getWaiterOrderCardAmounts(order).additionalAmt }} </span>
                  </div>
                  <div>
                    <span class="text-gray-600">TAX Amt:</span>
                    <span class="font-semibold text-gray-700 ml-1">{{ getWaiterOrderCardAmounts(order).taxAmt }} </span>
                  </div>
                  <div class="pt-0.5">
                    <span class="font-semibold text-gray-700">Grand Total: {{ getWaiterOrderCardAmounts(order).grandTotal }} </span>
                  </div>
                </div>
              </div>

              <div class="pt-1 w-full">
                <button
                  type="button"
                  @click="editWaiterOrderCard(order.id)"
                  class="w-full px-2 py-0.5 text-xs bg-[#0d4169] text-white rounded-sm hover:bg-[#0a3354] font-semibold shadow-sm"
                >
                  Edit
                </button>
              </div>
              <div class="w-full mt-1 flex justify-start">
                <button
                  type="button"
                  @click="scanWaiterOrderCard(order.id)"
                  class="w-1/2 px-2 py-0.5 text-xs bg-[#0d4169] text-white rounded-sm hover:bg-[#0a3354] font-semibold shadow-sm flex items-center justify-center gap-1"
                  title="Scan payment transaction"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="7" height="7"></rect>
                    <rect x="14" y="3" width="7" height="7"></rect>
                    <rect x="3" y="14" width="7" height="7"></rect>
                    <path d="M14 14h.01"></path>
                    <path d="M20 14h.01"></path>
                    <path d="M14 20h.01"></path>
                    <path d="M20 20h.01"></path>
                    <path d="M17 17h.01"></path>
                    <path d="M17 20h.01"></path>
                    <path d="M20 17h.01"></path>
                  </svg>
                  Scan
                </button>
              </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
        <!-- search -->
        <input
          v-model="searchTerm"
          type="text"
          placeholder="Search..."
          class="w-60 px-2 py-1 border border-gray-300 rounded-md text-sm shadow-sm
                 focus:border-[#add8e6] focus:outline-none focus:ring-1 focus:ring-[#add8e6]"
        />

        <!-- departments -->
  

<!-- Added outline-none to remove the focus border -->
<div class="flex w-full overflow-x-auto outline-none" style="scrollbar-width:none; -ms-overflow-style:none;" tabindex="-1">
  <div
    v-for="(dept,index) in departments"
    :key="dept.id"
    @click="selectDept(dept)"
    :class="[
      'flex-1 min-w-fit px-4 text-sm whitespace-nowrap cursor-pointer h-9 flex items-center justify-center flex-shrink-0',
      /* Keep existing border logic */
      index === 0 ? 'rounded-l-sm' : '',
      index === departments.length - 1 ? 'rounded-r-sm' : '',
      selectedDept && selectedDept.id === dept.id
        ? 'bg-green-700 text-white border-none shadow-none text-bold'
        : 'text-gray-800 hover:bg-gray-100 border border-gray-300'
    ]"
  >
    {{ dept.name }}
  </div>
</div>




        <!-- sub departments -->
        <div 
          v-if="selectedDept && selectedDept.subDepartments && selectedDept.subDepartments.length" 
          class="flex overflow-x-auto" 
          style="scrollbar-width:none; -ms-overflow-style:none;" 
          tabindex="-1"
        >
          <div
            v-for="(sub,index) in selectedDept.subDepartments"
            :key="sub.id"
            @click="selectSub(sub)"
            :class="[
              'px-2 text-xs whitespace-nowrap capitalize cursor-pointer h-8 min-h-8 flex items-center justify-center flex-shrink-0 border border-[#0d4169]',
              index === 0 ? 'rounded-l-sm' : '',
              index === selectedDept.subDepartments.length - 1 ? 'rounded-r-sm' : '',
              selectedSub && selectedSub.id === sub.id
                ? ' text-[0d4169] border-green-700 border-1px text-[#0d4169] font-bold'
                : 'text-[#0d4169] font-bold hover:bg-gray-100 border border-gray-300'
            ]"
            :style="{ minWidth: '60px' }"
          >
            {{ sub.name }}
          </div>
        </div>

        <!-- menus grid -->
        <div class="">
          <div class="grid gap-1 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-3">
          <div
  v-for="menu in filteredMenus"
  :key="menu.id || menu._id || menu.code"
  @click="((menu.isAvailable ?? menu.is_available ?? 1) === 1) ? addToBill(menu) : null"
  class="cursor-pointer border rounded-lg p-2 flex flex-col justify-between bg-white shadow-lg hover:shadow-xl transition-all duration-150 active:bg-[#1a5a8a] active:text-white"
  :class="{ 
    'cursor-not-allowed grayscale-[0.5]': (menu.isAvailable ?? menu.is_available ?? 1) === 0 
  }"
>
  <div>
    <h4 
      class="text-base font-semibold transition-colors duration-150"
      :class="{ 'text-red-600': (menu.isAvailable ?? menu.is_available ?? 1) === 0 }"
    >
      {{ menu.name }}
    </h4>

    <p 
      class="text-sm text-gray-600 mt-1 transition-colors duration-150"
      :class="{ 'text-red-400': (menu.isAvailable ?? menu.is_available ?? 1) === 0 }"
    >
      {{ ((Number(menu.totalPrice ?? menu.total_price) || 0).toFixed(2)) }}
    </p>
  </div>
</div>

            <div
              v-if="filteredMenus.length === 0"
              class="col-span-full text-center py-10 font-bold"
              style="color: #0d4169;"
            >
             <div class="text-2xl">Wellcome Back,</div>
             <div class="text-lg opacity-80 mt-2">Have you a nice day!</div>
             <div 
               class="text-sm mt-4 font-medium"
               :class="departments.length === 0 ? 'text-red-600' : 'opacity-60'"
             >
               {{ departments.length === 0 ? 'No department to select' : 'Select department to continue' }}
             </div>
            </div>
          </div>
        </div>
        </template>

      </div>
    </div>

    <!-- RIGHT SIDE -->
    <div v-if="!showWaiterOrderCards" class="w-full md:w-1/3  ">
      <div class="flex flex-col bg-white rounded-lg shadow-lg border-l border-gray-200">

        <!-- action buttons above bill -->
       <div class="flex flex-col p-4 pt-1 pr-1 pl-2 pb-2 border-b border-gray-100 overflow-hidden bg-gray-50/50">
       <div class="flex items-center justify-between flex-nowrap">
  
  <!-- LEFT SIDE -->
  <div class="flex items-center space-x-1 overflow-hidden">
    
    <div class="relative inline-flex items-start mr-3">
      <button 
        @click="() => { clearBillAreaOnly(); showTransferModal = true; }"
        class="px-2 py-1 text-sm border border-gray-300 rounded-sm hover:bg-gray-100 bg-white shadow-sm font-semibold text-gray-700"
      >
        Transfer
      </button>

      <span 
        v-if="transferBadgeCount > 0"
        class="absolute top-1.5 left-2 -translate-y-1/2 -translate-x-1/2 bg-red-600 text-white text-[9px] w-4 h-3 px-1 rounded-full flex items-center justify-center font-bold shadow z-50"
      >
        {{ transferBadgeCount }}
      </span>
    </div>

    <button
      v-if="isWaiterRole"
      @click="handleOrdersButtonClick"
      :class="['px-2 py-1 text-[12px] border rounded-sm flex-shrink-0 font-semibold shadow-sm transition-all', showWaiterOrderCards ? 'bg-blue-600 text-white border-blue-600' : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-100']"
    >
      My Orders
    </button>

    <select
      v-else
      v-model="allOrdersWaiterFilter"
      @change="handleAllOrdersWaiterSelect"
      class="px-2 py-1 text-[12px] border border-gray-300 rounded-sm flex-shrink-0 font-semibold shadow-sm outline-none bg-white text-gray-700 hover:bg-gray-100 max-w-[140px]"
    >
      <option value="" disabled>Select Waiter</option>
      <option value="__all__">All Waiters</option>
      <option v-for="user in waiters" :key="user.id" :value="user.id">
        {{ user.full_name || user.username }}
      </option>
    </select>
  </div>

  <!-- RIGHT SIDE -->
  <span 
    v-if="selectedOrderDate" 
    class="text-[10px] font-black text-[#0d4169] bg-white px-1 py-1 whitespace-nowrap"
  >
    {{ selectedOrderDate }}
  </span>

</div>
</div>

        <hr>
     <!-- Changed items-center to items-stretch and added flex to children -->
        <!-- NEW HEADER LAYOUT -->
      

<div class="bg-[#0d4169] pb-2">

  <!-- TOP GRID: LEFT + RIGHT -->
  <div class="grid grid-cols-[minmax(108px,_auto)_1fr] py-2 border-b border-gray-100 px-2">
    
    <!-- LEFT -->
    <div class="text-left flex flex-col space-y-1 h-full pr-2 ">
      <div class="flex flex-col">
        <div v-if="tableError && !isDelivery" class="text-[10px] font-bold text-red-500 mt-0.5 animate-bounce">
          Select Table Number
        </div>

        <div class="text-white text-[15px] font-bold tracking-tight whitespace-nowrap">
          Table &nbsp;
          <span class="font-bold">
            {{ String(tableNumber).length <=5 ? tableNumber || '---' : '---' }}
          </span>

          <button 
            v-if="tableNumber" 
            @click="tableNumber = ''" 
            :disabled="!!currentEditingOrderId"
            :class="currentEditingOrderId ? 'opacity-50 cursor-not-allowed' : 'hover:text-red-700'"
            class="text-red-500 text-sm ml-1"
          >
            ×
          </button>
        </div>
      </div>

      <hr>

      <div class="flex flex-col text-white">
        <div class="text-[12px] font-bold capitalize leading-tight">Waiter</div>
        <div class="text-[15px] font-bold capitalize tracking-tight whitespace-nowrap">
          {{ selectedWaiter.split(" ")[0] }}
        </div>
      </div>
    </div>

    <!-- RIGHT -->
    <div class="flex flex-col space-y-1 pl-2 border-l border-gray-100 w-full">
      <!-- Row 1 -->
      <div class="flex w-full space-x-1">
        <button 
          v-for="n in [1, 2, 3, 4, 5]" 
          :key="n"
          @click="appendTableNumber(n)"
          :disabled="!!currentEditingOrderId || viewMode === 'orders'"
          class="active:bg-[#1a5a8a] active:text-white flex-1 h-8 flex items-center justify-center border border-gray-200 text-[16px] font-black bg-gray-50 hover:bg-white text-gray-700 rounded shadow-sm hover:shadow active:translate-y-px transition-all"
          :class="!!currentEditingOrderId || viewMode === 'orders' ? 'opacity-50 cursor-not-allowed hover:bg-gray-50 active:translate-y-0' : ''"
        >
          {{ n }}
        </button>
      </div>

      <!-- Row 2 -->
      <div class="flex w-full space-x-1">
        <button 
          v-for="n in [6, 7, 8, 9, 0]" 
          :key="n"
          @click="appendTableNumber(n)"
          :disabled="!!currentEditingOrderId || viewMode === 'orders'"
          class="active:bg-[#1a5a8a] active:text-white flex-1 h-8 flex items-center justify-center border border-gray-200 text-[16px] font-black bg-gray-50 hover:bg-white text-gray-700 rounded shadow-sm hover:shadow active:translate-y-px transition-all"
          :class="!!currentEditingOrderId || viewMode === 'orders' ? 'opacity-50 cursor-not-allowed hover:bg-gray-50 active:translate-y-0' : ''"
        >
          {{ n }}
        </button>
      </div>
    </div>

  </div> <!-- end of grid -->

  <!-- FULL-WIDTH ROW BELOW GRID for Captain Order -->
  <div class="w-full mt-1 px-2">
    <div class="w-full text-center text-[14px] font-black text-[#0d4169] bg-white px-1 py-0 capitalize">
      Captain Order
    </div>
  </div>

</div>

        <hr>
        <div ref="billContainer" class="p-4 pr-1 pl-1 pb-12 flex-1 overflow-y-auto" @scroll="clearHoveredAllOrder">          <!-- CURRENT BILL VIEW -->
          <template v-if="viewMode === 'bill'">
            <div >
               <!-- Print Failure Alert -->
               <div v-if="printFailures.length > 0" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 font-bold animate-pulse text-center shadow-sm">
                 <div class="text-sm">⚠️ Printing Failed</div>
                 <div v-for="dept in printFailures" :key="dept" class="text-[11px] mt-1">{{ dept }}</div>
                 <div class="text-[10px] mt-1 text-green-600">But the Order was saved.</div>
               </div>

               <!-- bill header titles -->
            <div class="flex items-center mb-2 space-x-2 font-semibold text-sm">
              <span v-if="!currentEditingOrderId" class="w-4 text-center"></span>
              <span v-if="currentEditingOrderId" class="w-11 text-left">Qty</span>
              <span v-else class="w-4 pl-2 text-center">Qty</span>
              

              <span class="flex-1">Name</span>
              <span v-if="currentEditingOrderId" class="text-left text-[9px] leading-tight pr-2">U.P</span>
              <span v-if="currentEditingOrderId" class="text-left text-[9px] leading-tight pr-1">T.P</span>
              
              <div class="flex items-left space-x-1 pl-1">
                <button 
                  v-if="billItems.length > 0 && currentEditingOrderId && canVoidOrder" 
                  @click="clearBill()"
                  class="flex text-red-600 items-center border border-gray-200 justify-left px-0.5 h-4 rounded-sm hover:bg-gray-100 transition-colors duration-200"
                  title="Void Entire Order"
                >
                  <span class="text-[12px]">Void</span>
                </button>
                <input 
                  v-if="billItems.length > 0 && currentEditingOrderId"
                  type="checkbox"
                  @change="e => billItems.forEach(i => i.selected = e.target.checked)"
                  class="w-3 h-4 rounded border-gray-100 text-blue-600 focus:ring-blue-500 transition-all cursor-pointer"
                  title="Select All for Transfer"
                  :disabled="!isOwnOrder && !isAdmin"
                  :class="(!isOwnOrder && !isAdmin) ? 'opacity-50 cursor-not-allowed grayscale' : ''"
                />
              </div>
            </div>

            <!-- bill items -->
            <div
              v-for="item in sortedBillItems"
              :key="item.itemId || item.transferredItemId || item.localId"
              class="flex flex-col mb-2 border rounded-sm relative"
              :class="item.transferredQty > 0
                ? 'bg-green-100/70 border-green-300'
                : item.itemId && (item.ownNotPrintedCount || 0) > 0
                  ? 'bg-gray-50/20 border-blue-50/50'
                  : 'bg-gray-50/20 border-blue-50/50'"
            >
              <span 
                v-if="(item.itemId || item.transferredItemId) && ((item.transferredNotPrintedCount || 0) + (item.ownNotPrintedCount || 0)) > 0" 
                class="absolute -top-1.5 -left-1.4 z-10 bg-red-500 text-white text-[8px] w-3 h-3 flex items-center justify-center rounded-full font-bold shadow-sm"
                title="Quantity failed to print"
              >
                {{ (item.transferredNotPrintedCount || 0) + (item.ownNotPrintedCount || 0) }}
              </span>
              <div class="flex items-center p-1 px-0 space-x-2">
                <button v-if="!item.itemId && !item.transferredItemId" @click="changeQty(item, item.qty + 1)" class="text-green-600 text-sm px-1">+</button>
                <input
                  type="number"
                  v-model.number="item.qty"
                  :readonly="!!item.itemId || !!item.transferredItemId"
                  @change="changeQty(item, item.qty)"
                  class="w-7 text-center text-sm border rounded focus:outline-none focus:border-[#add8e6] no-spinner"
                  :class="(item.itemId || item.transferredItemId) ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : ''"
                />
                <button 
                  @click="changeQty(item, item.qty - 1)" 
                  :disabled="!canVoidOrder && (item.itemId || item.transferredItemId)"
                  :class="['text-red-600 text-sm px-1', (!canVoidOrder && (item.itemId || item.transferredItemId)) ? 'opacity-50 cursor-not-allowed' : '']"
                >–</button>
                <div class="flex-1 min-w-0 pr-1 cursor-pointer relative group flex flex-col justify-center" @click="toggleExpansion(item)">
                  <span 
                    class="text-[13px] truncate leading-tight"
                    :class="{ 'text-red-600 font-bold': (item.itemId || item.transferredItemId) &&((item.ownNotPrintedCount || 0) > 0 || (item.transferredNotPrintedCount || 0) > 0)}"
                  >
                    {{ item.menu.name }}
                  </span>
                  <p v-if="item.itemId || item.transferredItemId" class="text-[9px] text-blue-500 absolute left-0 transform transition-transform duration-200" :class="[item.isExpanded ? 'rotate-180' : '', (!item.notPrintedCount || item.notPrintedCount === 0) ? 'bottom-0' : '-bottom-3']">▼</p>
                </div>
                
                <div v-if="item.itemId || item.transferredItemId" class="w-6 text-right text-[9px] text-gray-500 self-center font-medium">
                  {{ Number(item.menu.totalPrice || 0).toFixed(1) }}
                </div>
                <div v-if="item.itemId || item.transferredItemId" class="w-6 text-right text-[9px] font-bold text-gray-700 self-center pr-1">
                  {{ (item.qty * Number(item.menu.totalPrice || 0)).toFixed(1) }}
                </div>

                <div class="flex items-center space-x-1 pl-1">
                  <!-- Expansion button for NEW items only on the right side -->
                  <button 
                    v-if="!item.itemId && !item.transferredItemId"
                    @click="toggleExpansion(item)"
                    class="p-1 text-blue-500 hover:bg-blue-50 rounded transition-colors"
                  >
                    <span class="text-[10px] transform transition-transform duration-200 block" :class="item.isExpanded ? 'rotate-180' : ''">▼</span>
                  </button>

                  <button 
                    v-if="canVoidOrder || !item.orderId"
                    @click="removeFromBill(item)" 
                    :disabled="!canVoidOrder && !!item.orderId"
                    :class="['text-red-500 text-sm px-1', (!canVoidOrder && !!item.orderId) ? 'opacity-50 cursor-not-allowed' : '']"
                    title="Remove Item"
                  >×</button>
                  
                  <input 
                    v-if="item.orderId"
                    type="checkbox"
                    v-model="item.selected"
                    class="w-3 h-4 rounded border-gray-100 text-blue-600 focus:ring-blue-500 transition-all cursor-pointer mx-1"
                    :disabled="!isOwnOrder && !isAdmin"
                    :class="(!isOwnOrder && !isAdmin) ? 'opacity-50 cursor-not-allowed grayscale' : ''"
                  />
                </div>
              </div>

              <!-- Ingredients Expansion Panel -->
              <Transition
                enter-active-class="transition duration-100 ease-out"
                enter-from-class="max-h-0 opacity-0"
                enter-to-class="max-h-60 opacity-100"
                leave-active-class="transition duration-75 ease-in"
                leave-from-class="max-h-60 opacity-100"
                leave-to-class="max-h-0 opacity-0"
              >
                <div v-if="item.isExpanded" class="p-3 bg-white border-t border-gray-50 overflow-hidden">
                  <div class="text-[14px] text-gray-800 capitalize tracking-wider mb-2">Note</div>
                  <input
                    v-model="item.note"
                    type="text"
                    :readonly="!!item.itemId || !!item.transferredItemId"
                    placeholder="Write note here..."
                    class="w-full mb-3 px-3 py-1.5 border border-gray-200 rounded text-sm outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all"
                   :class="(item.itemId || item.transferredItemId) ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : ''"
                  />
                  
                  <div v-if="item.ingredients && item.ingredients.length">
                    <div class="text-[14px] text-gray-800 capitalize tracking-wider mb-2">Customize Ingredients</div>
                  <div class="grid grid-cols-1 gap-2">
  <div
    v-for="ing in item.ingredients"
    :key="ing.id"
    class="flex items-center space-x-2 p-1.5 hover:bg-gray-50 rounded transition-colors group"
    :class="(item.itemId || item.transferredItemId) ? 'opacity-70' : ''"
  >
    <input 
      type="checkbox" 
      v-model="ing.checked" 
      :disabled="!!item.itemId || !!item.transferredItemId"
      class="w-3.5 h-3.5 rounded text-blue-600 focus:ring-blue-500 border-gray-300 transition-all"
      :class="(item.itemId || item.transferredItemId) ? 'cursor-not-allowed bg-gray-100' : 'cursor-pointer'"
    />
    <span 
      class="text-xs text-gray-600 group-hover:text-gray-900 transition-colors truncate"
      :class="!ing.checked ? 'line-through text-gray-400' : ''"
    >
      {{ ing.name }}
    </span>
  </div>
</div>
                  </div>
                </div>
              </Transition>
            </div>

            <div v-if="billItems.length === 0" class="text-gray-500 text-sm italic py-4">
              No items added.
            </div>

            <div class="mt-4 mb-4 text-right">
              <!-- Waiter Transfer UI -->
              <div v-if="billItems.some(i => i.selected && i.orderId)" class="mb-4 p-2 bg-blue-50 rounded-sm border border-blue-100 animate-in slide-in-from-bottom-2">
                <div class="flex space-x-1">
                  <select 
                    v-model="selectedWaiterId"
                    class="flex-1 text-xs border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none bg-white"
                  >
                    <option value="" disabled>Select Waiter</option>
                    <option v-for="user in waiters" :key="user.id" :value="user.id">
                      {{ user.full_name || user.username }}
                    </option>
                  </select>
                  <button 
                    @click="transferSelectedItems"
                    :disabled="!isOwnOrder"
                    class="px-3 py-1 bg-blue-600 text-white rounded-sm text-xs font-bold hover:bg-blue-700 transition-colors shadow-sm disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                   Accept
                  </button>
                </div>
              </div>

              <div class="pt-2 pr-2 border-t border-gray-100 text-right space-y-0.5 text-[11px]">
                <div>
                  <span class="text-gray-600">Base Amt:</span>
                  <span class="font-semibold text-gray-700 ml-1">{{ billAmountSummary.baseAmt }} </span>
                </div>
                <div>
                  <span class="text-gray-600">Additional Amt:</span>
                  <span class="font-semibold text-gray-700 ml-1">{{ billAmountSummary.additionalAmt }} </span>
                </div>
                <div>
                  <span class="text-gray-600">TAX Amt:</span>
                  <span class="font-semibold text-gray-700 ml-1">{{ billAmountSummary.taxAmt }} </span>
                </div>
                <div class="pt-0.5">
                  <span class="font-semibold text-gray-700">Grand Total: {{ billAmountSummary.grandTotal }} </span>
                </div>
              </div>
            </div>

            <!-- action buttons below total -->
            <div class="flex pr-2 pl-2 flex-col space-y-2">
              <!-- First Row: Clear, Delivery, Send -->
              <div class="flex space-x-1">
                <button 
                  @click="handleBackOrClear" 
                  class="flex-1 px-2 py-1 text-sm bg-red-500 text-white rounded-sm hover:bg-red-600"
                >
                  {{ currentEditingOrderId ? 'Back' : 'Clear' }}
                </button>
                <button 
                  @click="isDelivery = !isDelivery" 
                  :class="[
                    'flex-1 px-2 py-1 text-sm border rounded-sm transition-colors',
                    isDelivery ? 'bg-orange-600 text-white border-orange-600' : 'bg-orange-700 text-white border-orange-500 hover:bg-orange-600'
                  ]"
                >
                  Delivery
                </button>
                   <!-- the 1==3 is for comment  -->
                <button v-if="1==3"
                  @click="sendOrder" 
                     :disabled="isSending || (currentEditingOrderId ? (!canEditOrder || isEditingBeforeTodayOrder || isEditingOtherWaiterOrder) : !canAddOrder)"
                  class="flex-1 px-2 py-1 text-sm bg-blue-600 text-white rounded-sm hover:bg-blue-600 disabled:bg-blue-400 disabled:cursor-not-allowed flex items-center justify-center min-h-[32px]"
                     :title="currentEditingOrderId ? (!canEditOrder ? 'You do not have Edit privileges for Orders' : isEditingBeforeTodayOrder ? 'Orders before today cannot be updated' : isEditingOtherWaiterOrder ? 'Only the assigned waiter can update this order' : '') : (!canAddOrder ? 'You do not have Add privileges for Orders' : '')"
                >
                  <span v-if="isSending" class="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  <span v-else>{{ currentEditingOrderId ? 'Update' : 'Send' }}</span>
                </button>
              </div>

              <!-- Second Row: Delivery Company & Code (Conditional) -->
              <div v-if="isDelivery" class="flex space-x-2">
                <select 
                  v-model="deliveryCompany" 
                  class="flex-1 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                >
                  <option value="" disabled>Delivery Company</option>
                  <option v-for="c in deliveryCompanies" :key="c.id" :value="String(c.id)">{{ c.name }}</option>
                </select>
                <input 
                  v-model="deliveryCode" 
                  type="text" 
                  placeholder="Code" 
                  class="w-20 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                />
              </div>
<!-- if user has privilege to approve order -->
              <!-- Third Row: Confirm + Scan -->
               <!-- the 1==3 is for comment  -->
              <div  class="w-full pt-1 flex gap-2" v-if="1==3">
                <button 
                  v-if="canConfirmOrder"
                  @click="confirmBill" 
                  class="flex-1 px-2 py-1 text-sm bg-green-600 text-white rounded-sm hover:bg-green-700 transition-colors tracking-wider disabled:bg-green-400 disabled:cursor-not-allowed disabled:hover:bg-green-400"
                >
                  Confirm
                </button>
                <button
                  type="button"
                  @click="openScanPaymentModal"
                  :class="[
                    'px-2 py-1 text-sm bg-[#0d4169] text-white rounded-sm hover:bg-[#0a3555] transition-colors flex items-center justify-center',
                    canConfirmOrder ? 'w-10 shrink-0' : 'flex-1'
                  ]"
                  title="Scan payment transaction"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="7" height="7"></rect>
                    <rect x="14" y="3" width="7" height="7"></rect>
                    <rect x="3" y="14" width="7" height="7"></rect>
                    <path d="M14 14h.01"></path>
                    <path d="M20 14h.01"></path>
                    <path d="M14 20h.01"></path>
                    <path d="M20 20h.01"></path>
                    <path d="M17 17h.01"></path>
                    <path d="M17 20h.01"></path>
                    <path d="M20 17h.01"></path>
                  </svg>
                </button>
              </div>
            </div>
            </div>
           
          </template>

          <!-- ALL ORDERS INLINE VIEW -->
          <template v-else>
            <div class="p-0">
              
              <table class="w-full">
                <thead class="bg-gray-50 sticky top-0">
                  <tr class="text-[11px]">
                    <th class="py-1 px-0.5 border-b w-[22%]">Date</th>
                    <th class="py-1 px-0.5 border-b w-[20%]">Name</th>
                    <th class="py-1 px-0.5 border-b w-[12%] text-center">O. No</th>
                    <th class="py-1 px-0.5 border-b w-[12%] text-center">Table</th>
                    <th class="py-1 px-0.5 border-b w-[18%] text-right pr-1">TP</th>
                    <th class="py-1 px-0.5 border-b w-[8%]"></th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Today Orders -->
                  <tr 
                    v-for="order in filteredTodayOrders" 
                    :key="order.id" 
                    @click="onAllOrderRowClick(order.id)"
                    @mouseenter="onAllOrderRowEnter(order, $event)"
                    @mouseleave="clearHoveredAllOrder"
                    class="hover:bg-yellow-200 cursor-pointer transition-colors text-[11px]"
                    :class="{
                      'bg-green-100/70 border-y border-green-300': order.transferStatus === 1,
                      'bg-orange-100/50': order.transferStatus === 0 && order.transferStatus !== 1 && !order.isAnyUnprinted
                    }"
                  >
                    <td class="py-1 px-0.5 border-b truncate">
                      <div class="flex items-center">
                        {{ order.createdAt ? order.createdAt.split('T')[0] : '---' }}
                      </div>
                    </td>
                    <td 
                      class="py-1 px-0.5 border-b truncate"
                      :class="{ 'text-red-600 font-bold italic': order.isAnyUnprinted }"
                    >{{ order.waiterName }}</td>
                    <td class="py-1 px-0.5 border-b text-center align-middle">
                      <div class="flex items-center justify-center truncate">{{ order.dailyOrderNo ?? '---' }}</div>
                    </td>
                    <td class="py-1 px-0.5 border-b text-center align-middle">
                      <div class="flex items-center justify-center truncate">{{ String(order.table).length <=5 ? order.table || '---' : '---' }}</div>
                    </td>
                    <td class="py-1 px-0.5 border-b font-bold text-right pr-1 truncate">{{ (order.totalPriceSum || 0).toFixed(2) }}</td>
                    <td class="py-1 px-0.5 border-b text-center">
                      <svg v-if="order.hasPendingTransfer" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0d4169" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="inline-block">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </td>
                  </tr>

                  <!-- Before Today Title Row -->
                 <tr v-if="filteredBeforeTodayOrders.length > 0" class="text-center py-0">
  <td colspan="6"
      class="py-0 px-2 bg-red-600 border-y border-red-100 text-white font-bold  text-[13px] capitalize tracking-widest text-center align-middle">
    <div class="w-full text-center">
      Before Today Orders
    </div>
  </td>
</tr>

                  <!-- Before Today Orders -->
                  <tr 
                    v-for="order in filteredBeforeTodayOrders" 
                    :key="order.id" 
                    @click="onAllOrderRowClick(order.id)"
                    @mouseenter="onAllOrderRowEnter(order, $event)"
                    @mouseleave="clearHoveredAllOrder"
                    class="hover:bg-yellow-200 cursor-pointer transition-colors text-[11px]"
                    :class="{
                      'bg-green-100/70 border-y border-green-300': order.transferStatus === 1,
                      'bg-orange-100/50': order.transferStatus === 0 && order.transferStatus !== 1 && !order.isAnyUnprinted
                    }"
                  >
                    <td class="py-1 px-0.5 border-b truncate">
                      <div class="flex items-center">
                        {{ order.createdAt ? order.createdAt.split('T')[0] : '---' }}
                      </div>
                    </td>
                    <td 
                      class="py-1 px-0.5 border-b truncate"
                      :class="{ 'text-red-600 font-bold italic': order.isAnyUnprinted }"
                    >{{ order.waiterName }}</td>
                    <td class="py-1 px-0.5 border-b text-center align-middle">
                      <div class="flex items-center justify-center truncate">{{ order.dailyOrderNo ?? '---' }}</div>
                    </td>
                    <td class="py-1 px-0.5 border-b text-center align-middle">
                      <div class="flex items-center justify-center truncate">{{ String(order.table).length <=5 ? order.table || '---' : '---' }}</div>
                    </td>
                    <td class="py-1 px-0.5 border-b font-bold text-right pr-1 truncate">{{ (order.totalPriceSum || 0).toFixed(2) }}</td>
                    <td class="py-1 px-0.5 border-b text-center">
                      <svg v-if="order.hasPendingTransfer" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0d4169" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="inline-block">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </td>
                  </tr>

                  <tr v-if="filteredTodayOrders.length === 0 && filteredBeforeTodayOrders.length === 0" class="text-center">
                    <td colspan="6" class="py-4 text-center text-gray-500 italic">No orders found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>

  <!-- All Orders row hover detail (same pattern as dashboard Weekly Total Orders tooltip) -->
  <Teleport to="body">
    <div
      v-if="hoveredAllOrder"
      ref="hoveredAllOrderEl"
      class="fixed z-[200] bg-white border border-slate-200 shadow-lg rounded-lg overflow-hidden pointer-events-none text-[11px] w-max min-w-[160px] max-w-[260px]"
      :style="hoveredAllOrderStyle"
    >
      <div class="bg-[#0d4169] text-white flex flex-wrap items-center justify-between gap-2 px-3 py-1.5 font-bold whitespace-nowrap">
        <span>{{ hoveredAllOrder.waiterName || '---' }}</span>
        <span>Table: {{ String(hoveredAllOrder.table).length <= 5 ? (hoveredAllOrder.table || '---') : '---' }}</span>
      </div>
      <div class="p-2">
        <div class="flex justify-between gap-6 font-bold text-slate-700 border-b border-slate-100 pb-1 mb-1 whitespace-nowrap">
          <span>Item</span>
          <span>Qty</span>
        </div>
        <div
          v-for="(item, idx) in getWaiterOrderCardItems(hoveredAllOrder)"
          :key="item.localId || idx"
          class="flex justify-between gap-6 py-1.5 border-b border-slate-50 last:border-0 whitespace-nowrap"
        >
          <span class="text-slate-600 font-medium truncate max-w-[180px]">{{ item.name }}:</span>
          <span class="font-bold text-slate-800">{{ item.qty }}</span>
        </div>
        <div v-if="getWaiterOrderCardItems(hoveredAllOrder).length === 0" class="text-slate-400 italic py-1">
          No items.
        </div>
      </div>
    </div>
  </Teleport>

  <!-- PAYMENT METHODS MODAL -->
<Transition name="fade">
  <div v-if="showPaymentModal" class="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
    <!-- Increased width to md for 4-column layout -->
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
      
      <!-- Compact Header -->
      <div class="px-4 py-3 flex justify-between items-center bg-[#0d4169]">
        <h3 class="text-sm font-bold text-white capitalize tracking-wide">Payment Methods</h3>
        <button @click="showPaymentModal = false; transactionId=''; scannedReceiverDisplay=''; resetCbeQrScanState()" class="w-6 h-6 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-lg">&times;</button>
      </div>

      <div class="p-4">
        <!-- Slim Amount Bar -->
        <div v-if="paymentPhase !== 'selection'" class="bg-slate-50 rounded-lg p-3 text-center mb-4 border border-slate-100">
          <span class="text-[10px] capitalize font-bold  tracking-wider">Total Amount</span>
          <div class="text-xl font-black text-[#0d4169] leading-none mt-1">
            {{ formatPaymentTotal(totalPrice) }}
          </div>
        </div>

        <!-- Phase 1: 4-Column Grid -->
        <div v-if="paymentPhase === 'selection'" class="pb-6">
          <div class="grid grid-cols-4 gap-2">
            <button 
              v-for="method in modalPaymentMethods" 
              :key="method.id"
              @click="handlePaymentSelection(method)"
              class="flex flex-col items-center justify-center p-3 border border-gray-200 rounded-lg hover:border-[#0d4169] hover:bg-blue-50/30 transition-all active:scale-95 bg-white group"
            >
              <div class="w-10 h-10 mb-1 group-hover:scale-110 transition-transform flex items-center justify-center overflow-hidden">
                <img v-if="method.logo" :src="resolveCompanyLogoUrl(method.logo)" class="w-full h-full object-contain rounded-md p-1 border border-slate-100 bg-slate-50/50 shadow-sm">
                <div v-else class="w-10 h-10 rounded-md bg-slate-100 flex items-center justify-center text-sm font-black text-slate-400 uppercase border border-slate-200">
                  {{ method.name.substring(0, 2) }}
                </div>
              </div>
              <span class="text-[10px] font-bold text-slate-600 capitalize text-center leading-tight">{{ method.name }}</span>
            </button>
          </div>
          <div v-if="modalPaymentMethods.length === 0" class="py-10 text-center text-slate-400 italic text-sm">
            No active payment methods.
          </div>
        </div>

        <!-- Phase 2: Condensed Details -->
        <div v-else class="animate-in slide-in-from-right-2 duration-200">
            <div class="flex items-center space-x-3 mb-4 bg-slate-50 p-2 rounded-lg border border-slate-100">
               <div v-if="selectedPaymentMethod?.logo" class="w-8 h-8 rounded bg-white flex items-center justify-center overflow-hidden border border-slate-200">
                  <img :src="resolveCompanyLogoUrl(selectedPaymentMethod.logo)" class="w-full h-full object-contain">
               </div>
               <div v-else class="w-8 h-8 rounded bg-white flex items-center justify-center text-xs font-bold text-slate-400 border border-slate-200 uppercase">
                  {{ selectedPaymentMethod?.name?.substring(0, 2) }}
               </div>
               <span class="text-sm font-bold text-[#0d4169] capitalize tracking-tight">{{ selectedPaymentMethod?.name }}</span>
            </div>
            
            <div class="space-y-4">
              <div class="flex flex-col items-start w-3/4 mx-auto">
                <label class="pl-4 text-[11px] font-bold text-slate-500 capitalize tracking-wider mb-1.5">
                  Customer Phone Number
                </label>
                <input 
                  v-model="customerPhone"
                  type="text"
                  placeholder="09..."
                  class="w-full px-3 py-1.5 bg-gray-50 border border-gray-200 rounded text-left text-sm focus:bg-white focus:border-[#0d4169] outline-none font-bold transition-all placeholder:font-normal"
                />
              </div>

              <div class="flex flex-col items-start w-3/4 mx-auto">
                <label class="pl-4 text-[11px] font-bold text-slate-500 capitalize tracking-wider mb-1.5">
                  Transaction ID
                </label>
                <div class="flex w-full items-center gap-2">
                  <button
                    type="button"
                    @click="openTxnScanPicker"
                    :disabled="isScanningTransaction"
                    class="shrink-0 w-9 h-[34px] flex items-center justify-center rounded border border-[#0d4169]/30 bg-[#0d4169]/5 text-[#0d4169] hover:bg-[#0d4169]/10 active:scale-95 transition-all disabled:opacity-50"
                    title="Scan transaction ID from screenshot or camera"
                  >
                    <svg v-if="!isScanningTransaction" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="3" y="3" width="7" height="7"></rect>
                      <rect x="14" y="3" width="7" height="7"></rect>
                      <rect x="3" y="14" width="7" height="7"></rect>
                      <path d="M14 14h.01"></path>
                      <path d="M20 14h.01"></path>
                      <path d="M14 20h.01"></path>
                      <path d="M20 20h.01"></path>
                      <path d="M17 17h.01"></path>
                      <path d="M17 20h.01"></path>
                      <path d="M20 17h.01"></path>
                    </svg>
                    <span v-else class="txn-scan-spinner"></span>
                  </button>
                  <input 
                    v-model="transactionId"
                    type="text"
                    placeholder="Enter transaction ID"
                    class="flex-1 min-w-0 px-3 py-1.5 bg-gray-50 border border-gray-200 rounded text-left text-sm focus:bg-white focus:border-[#0d4169] outline-none font-bold transition-all placeholder:font-normal"
                    @keyup.enter="markPaid(selectedPaymentMethod)"
                  />
                </div>
                <p
                  v-if="scannedReceiverDisplay"
                  class="w-full mt-1.5 pl-4 text-[11px] font-semibold text-slate-600 leading-snug break-words whitespace-pre-line"
                >
                  {{ scannedReceiverDisplay }}
                </p>
                <p
                  v-if="cbeQrStatusMessage"
                  class="w-full mt-0.5 pl-4 text-[10px] font-semibold leading-snug"
                  :class="{
                    'text-amber-600': cbeQrStatus === 'loading',
                    'text-emerald-600': cbeQrStatus === 'success',
                    'text-red-600': cbeQrStatus === 'error',
                  }"
                >
                  {{ cbeQrStatusMessage }}
                </p>
              </div>

              <!-- Actions: Back (Left) & Pay Now (Right) -->
              <div class="flex items-center justify-between pt-3 border-t border-gray-100">
                <button 
                  @click="paymentPhase = 'selection'" 
                  class="pl-1 text-[13px] font-bold hover:text-slate-600 transition-all capitalize tracking-tight flex items-center"
                >
                  <span class="mr-1">←</span> Back
                </button>
                
                <button 
                  @click="markPaid(selectedPaymentMethod)" 
                  :disabled="isSending"
                  class="px-5 py-2 bg-green-600 text-white rounded text-[11px] font-bold hover:bg-green-700 shadow-sm active:scale-95 transition-all capitalize tracking-wider flex items-center justify-center min-w-[70px] min-h-[36px]"
                >
                  <span v-if="isSending" class="spinner"></span>
                  <span v-else>Send</span>
                </button>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</Transition>

  <!-- TRANSACTION ID SCAN INPUTS -->
  <input ref="txnScanFileInput" type="file" accept="image/*" class="txn-scan-file-input" @change="handleTxnScanFile" />
  <input ref="txnScanCameraInput" type="file" accept="image/*" capture="environment" class="txn-scan-file-input" @change="handleTxnScanFile" />
  <Transition name="fade">
    <div
      v-if="showTxnScanSourcePicker"
      class="fixed inset-0 z-[110] flex items-end justify-center bg-slate-900/40"
      @click.self="closeTxnScanSourcePicker"
    >
      <div class="bg-white rounded-t-2xl shadow-2xl w-full max-w-md overflow-hidden px-4 pt-4 pb-6">
        <div class="flex gap-3">
          <button
            v-if="!isCbePaymentSelected"
            type="button"
            @click="pickTxnCameraFromSourcePicker"
            :disabled="isScanningTransaction"
            class="flex-1 flex flex-col items-center justify-center gap-2 p-3 rounded-xl border border-slate-200 bg-slate-50 active:scale-95 transition-all disabled:opacity-50"
          >
            <div class="w-11 h-11 rounded-full bg-[#0d4169]/10 flex items-center justify-center text-[#0d4169]">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                <circle cx="12" cy="13" r="4"></circle>
              </svg>
            </div>
            <span class="text-[11px] font-bold text-slate-700">Camera</span>
          </button>
          <button
            type="button"
            @click="pickTxnGalleryFromSourcePicker"
            :disabled="isScanningTransaction"
            class="flex-1 flex flex-col items-center justify-center gap-2 p-3 rounded-xl border border-slate-200 bg-slate-50 active:scale-95 transition-all disabled:opacity-50"
          >
            <div class="w-11 h-11 rounded-full bg-[#0d4169]/10 flex items-center justify-center text-[#0d4169]">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <path d="M21 15l-5-5L5 21"></path>
              </svg>
            </div>
            <span class="text-[11px] font-bold text-slate-700">Gallery</span>
          </button>
          <button
            v-if="isCbePaymentSelected"
            type="button"
            @click="pickTxnQrFromSourcePicker"
            :disabled="isScanningTransaction"
            class="flex-1 flex flex-col items-center justify-center gap-2 p-3 rounded-xl border border-slate-200 bg-slate-50 active:scale-95 transition-all disabled:opacity-50"
          >
            <div class="w-11 h-11 rounded-full bg-[#0d4169]/10 flex items-center justify-center text-[#0d4169]">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
                <path d="M14 14h.01"></path>
                <path d="M20 14h.01"></path>
                <path d="M14 20h.01"></path>
                <path d="M20 20h.01"></path>
                <path d="M17 17h.01"></path>
                <path d="M17 20h.01"></path>
                <path d="M20 17h.01"></path>
              </svg>
            </div>
            <span class="text-[11px] font-bold text-slate-700">QR Scan</span>
          </button>
        </div>
      </div>
    </div>
  </Transition>
  <Transition name="fade">
    <div v-if="showTxnLiveCameraScan" class="fixed inset-0 z-[110] bg-black flex flex-col">
      <div class="px-4 py-3 flex justify-between items-center bg-[#0d4169] shrink-0">
        <h3 class="text-sm font-bold text-white tracking-wide">{{ txnLiveScanPurpose === 'qr' ? 'Scan QR Code' : 'Scan Transaction ID' }}</h3>
        <button type="button" @click="closeLiveTxnCameraScan" class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-lg">&times;</button>
      </div>
      <div class="relative flex-1 min-h-0 bg-black">
        <video ref="txnLiveScanVideo" autoplay playsinline muted class="absolute inset-0 w-full h-full object-cover"></video>
        <div
          v-if="txnLiveScanPurpose === 'qr'"
          class="absolute inset-0 z-10 flex items-center justify-center pointer-events-none"
        >
          <div class="txn-qr-scan-frame">
            <span class="txn-qr-corner txn-qr-corner-tl"></span>
            <span class="txn-qr-corner txn-qr-corner-tr"></span>
            <span class="txn-qr-corner txn-qr-corner-bl"></span>
            <span class="txn-qr-corner txn-qr-corner-br"></span>
            <span class="txn-qr-scan-line"></span>
          </div>
        </div>
        <div class="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/85 via-black/50 to-transparent">
          <p class="text-white text-xs font-medium text-center">{{ txnLiveScanPurpose === 'qr' ? 'Align the CBE receipt QR inside the frame' : 'Point your camera at the transaction ID' }}</p>
          <p class="text-white/75 text-[10px] text-center mt-1">Scanning automatically — hold steady</p>
          <p v-if="txnLiveScanProcessing || cbeQrStatus === 'loading'" class="text-white/90 text-[10px] text-center mt-2 font-bold">
            {{ cbeQrStatus === 'loading' ? 'Fetching Transaction ID...' : 'Reading...' }}
          </p>
        </div>
      </div>
    </div>
  </Transition>
  <Transition name="fade">
    <div v-if="showTxnScanModal" class="fixed inset-0 z-[110] flex items-center justify-center bg-slate-900/70 backdrop-blur-sm p-4">
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden relative">
        <div v-if="isScanningTransaction" class="absolute inset-0 z-20 bg-white/92 flex flex-col items-center justify-center gap-3">
          <span class="txn-scan-spinner-lg"></span>
          <p class="text-sm font-bold text-[#0d4169]">Scanning...</p>
          <p class="text-[11px] text-slate-500 px-6 text-center">Reading payment screen locally. No image is uploaded.</p>
        </div>

        <div class="px-4 py-3 flex justify-between items-center bg-[#0d4169]">
          <h3 class="text-sm font-bold text-white tracking-wide">Scan Transaction ID</h3>
          <button type="button" @click="closeTxnScanModal" class="w-6 h-6 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-lg">&times;</button>
        </div>

        <div class="p-4 space-y-4">
          <div v-if="txnScanMode === 'chooser'" class="grid grid-cols-1 gap-3">
            <button
              type="button"
              @click="pickTxnScreenshot"
              :disabled="isScanningTransaction"
              class="w-full px-4 py-3 border border-slate-200 rounded-lg hover:border-[#0d4169] hover:bg-blue-50/40 transition-all text-left"
            >
              <div class="text-sm font-bold text-[#0d4169]">Upload Screenshot</div>
              <div class="text-[11px] text-slate-500 mt-0.5">Select a payment confirmation image from your device</div>
            </button>
            <button
              type="button"
              @click="startTxnCamera"
              :disabled="isScanningTransaction"
              class="w-full px-4 py-3 border border-slate-200 rounded-lg hover:border-[#0d4169] hover:bg-blue-50/40 transition-all text-left"
            >
              <div class="text-sm font-bold text-[#0d4169]">Use Camera</div>
              <div class="text-[11px] text-slate-500 mt-0.5">Point at another phone's payment screen and capture</div>
            </button>
          </div>

          <div v-else class="space-y-3">
            <video ref="txnScanVideo" autoplay playsinline muted class="w-full rounded-lg border border-slate-200 bg-black max-h-52 object-cover"></video>
            <div class="flex items-center justify-between gap-2">
              <button type="button" @click="txnScanMode = 'chooser'; stopTxnCamera()" class="text-[12px] font-bold text-slate-500 hover:text-slate-700">Back</button>
              <button
                type="button"
                @click="captureAndScanTransaction"
                :disabled="isScanningTransaction"
                class="px-4 py-2 bg-[#0d4169] text-white rounded text-[11px] font-bold hover:bg-[#0a3354] active:scale-95 transition-all disabled:opacity-50"
              >
                Capture &amp; Scan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>

  <!-- TRANSFER REQUESTS MODAL -->
  <Transition name="fade">
    <div v-if="showTransferModal" class="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        <!-- Modal Header -->
        <div class="px-5 py-3 flex justify-between items-center bg-[#0d4169]">
          <div>
            <h3 class="text-sm font-bold text-white tracking-wide">Transfer Requests</h3>
            <p class="text-[10px] text-white/70">{{ transferRequests.length }} pending request{{ transferRequests.length !== 1 ? 's' : '' }}</p>
          </div>
          <button @click="showTransferModal = false" class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-lg">&times;</button>
        </div>

        <!-- Cards Container -->
        <div class="p-4 max-h-[70vh] overflow-y-auto custom-scrollbar">
          <div v-if="transferRequests.length === 0" class="py-16 text-center text-gray-400 italic text-sm">
            No transfer requests pending.
          </div>
          <div v-else class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div 
              v-for="req in transferRequests"
              :key="req.id"
              class="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm flex flex-col"
            >
              <!-- Card Header -->
              <div class="bg-slate-50 border-b border-gray-200 px-3 py-2">
                <div class="flex items-center justify-between">
                  <span class="text-[13px] font-bold text-[#0d4169] capitalize">{{ req.waiter }}</span>
                  <span class="text-[10px] text-slate-400">{{ req.date }}</span>
                </div>
                <div class="flex items-center mt-0.5 space-x-3">
                  <span class="text-[10px] text-slate-500">Table: <span class="font-bold text-slate-700">            {{ String(req.table).length <=5 ? req.table || '---' : '---' }}</span></span>
                  <span class="text-[10px] text-slate-500">{{ req.items.length }} item{{ req.items.length !== 1 ? 's' : '' }}</span>
                </div>
              </div>

              <!-- Card Items Table -->
              <table class="w-full text-[11px] flex-1">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="py-1 px-2 border-b text-left w-[50%]">Menu</th>
                    <th class="py-1 px-2 border-b text-center w-[20%]">Qty</th>
                    <th class="py-1 px-2 border-b text-center w-[30%]">
                      <input type="checkbox" @change="toggleAllItems(req, $event.target.checked)" class="cursor-pointer" title="Select all" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in req.items" :key="item.id" class="hover:bg-blue-50/50 transition-colors">
                    <td class="py-1.5 px-2 border-b truncate">{{ item.menuName }}</td>
                    <td class="py-1.5 px-2 border-b text-center">{{ item.qty }}</td>
                    <td class="py-1.5 px-2 border-b text-center">
                      <input type="checkbox" v-model="item.selected" class="cursor-pointer" />
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Card Actions -->
              <div class="bg-gray-50 px-3 pl-2 py-2 border-t border-gray-100 flex flex-col space-y-2">
                
                <!-- Buttons at the top -->
                <div class="flex justify-end space-x-2 border-b border-gray-100 pb-1 gap-7">
                  <button
                    @click="toggleTransferAction(req.id, true)"
                    class="px-3 py-1 text-[11px] font-bold border rounded transition-all bg-green-50 text-green-600 border-green-200 hover:bg-green-600 hover:text-white"
                  >
                    Accept
                  </button>

                  <button
                    @click="() => {
                      let selected = req.items.filter(i => i.selected).map(i => i.transferId)
                      if (selected.length === 0) selected = req.items.map(i => i.transferId)
                      if (selected.length && confirmAction('Are you sure you want to reject the selected items?')) {
                        rejectTransfer(selected.join(','), req.id)
                      }
                    }"
                    class="px-3 py-1 text-[11px] font-bold border rounded transition-all bg-red-50 text-red-600 border-red-200 hover:bg-red-600 hover:text-white"
                  >
                    Reject
                  </button>
                </div>

                <!-- Action section (Hidden by default) -->
                <template v-if="transferUIState[req.id]?.showAction">
                  <!-- Choose Table View -->
                  <div v-if="!transferUIState[req.id].action || transferUIState[req.id].action === 'Merge'" class="w-full pt-1">
                    <span class="text-[11px] font-bold text-gray-500 block mb-1.5 text-left">Select existing table:</span>
                    <div class="flex flex-col w-full divide-y divide-gray-100 border-b border-gray-100 mb-2">
                      <button 
                        v-for="t in pendingTables" 
                        :key="t"
                        @click="transferUIState[req.id].action = 'Merge'; transferUIState[req.id].targetTable = t;"
                        :class="[
                          'px-3 py-2.5 text-[11px] font-bold transition-all w-full flex justify-between items-center',
                          transferUIState[req.id].action === 'Merge' && transferUIState[req.id].targetTable === t
                            ? 'bg-blue-600 text-white'
                            : 'bg-white text-gray-700 hover:bg-blue-50'
                        ]"
                      >
                        <span>Table Number</span>
                        <span>{{ String(t).length <=5 ? t || '---' : '---' }}</span>
                      </button>
                    </div>
                    <button 
                      @click="transferUIState[req.id].action = 'New Table'; transferUIState[req.id].targetTable = '';"
                      class="px-2 py-1 text-[11px] font-bold text-[#0d4169] hover:underline transition-all flex items-center justify-start"
                    >
                      <span class="mr-1 shrink-0 bg-[#0d4169]/10 text-[#0d4169] rounded-full w-4 h-4 flex flex-col justify-center items-center text-[10px] leading-none">+</span> New table
                    </button>
                  </div>

                  <!-- New Table Keypad (Numeric input) -->
                  <div v-if="transferUIState[req.id]?.action === 'New Table'" class="flex flex-col space-y-1">
                    <div class="flex items-center justify-between mb-1">
                      <span class="text-[11px] font-bold text-gray-500">New Table</span>
                      <button @click="transferUIState[req.id].action = ''; transferUIState[req.id].targetTable = '';" class="text-[10px] text-[#0d4169] hover:underline font-bold">← Back</button>
                    </div>
                    <div class="flex items-center justify-between border border-gray-200 rounded px-2 py-0.5 bg-white shadow-sm">
                        <span class="text-[15px] font-black text-[#0d4169]">Table: {{ transferUIState[req.id]?.targetTable || '---' }}</span>
                        <button @click="clearTransferTable(req.id)" class="text-red-500 text-sm hover:text-red-700 font-bold">×</button>
                    </div>
                    <!-- Keypad rows distributed across the whole row -->
                    <div class="grid grid-cols-5 gap-2 w-full">
                      <button 
                        v-for="n in [1, 2, 3, 4, 5]" 
                        :key="n"
                        @click="setTransferTableDigit(req.id, n)"
                        class="active:bg-[#1a5a8a] active:text-white w-full h-9 flex items-center justify-center border border-gray-200 text-[13px] font-black bg-gray-50 hover:bg-white text-gray-700 rounded shadow-sm hover:shadow active:translate-y-px transition-all"
                      >
                        {{ n }}
                      </button>
                      <button 
                        v-for="n in [6, 7, 8, 9, 0]" 
                        :key="n"
                        @click="setTransferTableDigit(req.id, n)"
                        class="active:bg-[#1a5a8a] active:text-white w-full h-9 flex items-center justify-center border border-gray-200 text-[13px] font-black bg-gray-50 hover:bg-white text-gray-700 rounded shadow-sm hover:shadow active:translate-y-px transition-all"
                      >
                        {{ n }}
                      </button>
                    </div>
                  </div>

                  <!-- Final Confirmation Button to use acceptTransfer -->
                  <div v-if="transferUIState[req.id]?.action" class="pt-2 border-t border-gray-100 mt-2">
                    <button
                      @click="() => {
                        const dest = resolveTransferDestination(req.id)
                        if (!dest) return
                        let selected = req.items.filter(i => i.selected).map(i => i.transferId)
                        if (selected.length === 0) selected = req.items.map(i => i.transferId)
                        // const action = transferUIState[req.id]?.action
                        // const target = transferUIState[req.id]?.targetTable
                        // && confirmAction(`Accept transfer to ${action}: Table ${target}?`)
                        if (selected.length) {
                          acceptTransfer(selected.join(','), dest.tableNumber, dest.orderGroupId, req.id)
                        }
                      }"
                      class="w-full py-1 text-[11px] font-bold border rounded transition-all bg-green-600 text-white border-green-700 hover:bg-green-700 shadow-sm"
                    >
                      Confirm Accept
                    </button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="bg-gray-50 px-5 py-3 flex justify-end border-t border-gray-100">
          <button 
            @click="showTransferModal = false" 
            class="px-5 py-1.5 bg-[#0d4169] text-white rounded text-xs font-bold hover:bg-[#0a3354] transition-all"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </Transition>
  
  <!-- Toast Notification -->
  <Transition name="toast">
    <div v-if="toast.show" class="fixed top-4 right-4 z-[1000] max-w-sm">
      <div 
        :class="[
          'px-6 py-3 rounded-lg shadow-2xl text-white flex items-center gap-3 min-w-[300px]',
          toast.type === 'success' ? 'bg-green-600' : 'bg-red-600'
        ]"
      >
        <span v-if="toast.type == 'success'">✅</span>
        <span v-else>❌</span>
        <span class="font-medium">{{ toast.message }}</span>
      </div>
    </div>
  </Transition>

</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { BrowserMultiFormatReader } from '@zxing/browser'
import store from '../../store'
import { apiFetch, WS_BASE_URL, normalizeUploadValue, resolveCompanyLogoUrl } from '../../utils/api'

// Helper for template to use window.confirm
const confirmAction = (msg) => window.confirm(msg)


const currentUser = computed(() => store.getters.currentUser)
const isAdmin = computed(() => currentUser.value?.role === 'Admin')

const userPrivileges = computed(() => {
  if (!currentUser.value?.privilege) return {}
  return typeof currentUser.value.privilege === 'string' 
    ? JSON.parse(currentUser.value.privilege) 
    : currentUser.value.privilege
})

const hasAdminPrivilege = computed(() => userPrivileges.value?.all === true)

const canAddOrder = computed(() => {
  if (hasAdminPrivilege.value) return true
  const orders = userPrivileges.value?.Orders || userPrivileges.value?.orders
  return !!orders?.Add
})

const canEditOrder = computed(() => {
  if (hasAdminPrivilege.value) return true
  const orders = userPrivileges.value?.Orders || userPrivileges.value?.orders
  return !!orders?.Edit
})

const canViewAllOrders = computed(() => {
  if (hasAdminPrivilege.value) return true
  const orders = userPrivileges.value?.Orders || userPrivileges.value?.orders
  return !!orders?.View
})

const isWaiterRole = computed(() => {
  const role = currentUser.value?.role
  if (!role) return false
  return String(role).split(',').map(r => r.trim().toLowerCase()).includes('waiter')
})

const showWaiterOrderCards = ref(false)

const canVoidOrder = computed(() => {
  if (hasAdminPrivilege.value) return true
  const orders = userPrivileges.value?.Orders || userPrivileges.value?.orders
  return !!orders?.Void
})

const canConfirmOrder = computed(() => {
  // if (hasAdminPrivilege.value) return true
  const orders = userPrivileges.value?.Orders || userPrivileges.value?.orders
  // Orders uses Confirm in UserModal; keep Approve fallback for older saved privileges
  return !!(orders?.Confirm ?? orders?.Approve)
})

// const canClickConfirmBill = computed(() => {
//   if (billItems.value.length === 0) return false
//   return billItems.value.every(item =>
//     (item.transferredNotPrintedCount || 0) === 0 && (item.ownNotPrintedCount || 0) === 0
//   )
// })

// Check if currently editing an order that belongs strictly to the user
const isOwnOrder = computed(() => {
  if (!currentEditingOrderId.value) return true // New orders belong to user
  const order = orderGroups.value.find(o => o.id === currentEditingOrderId.value)
  if (!order) return false
  const uid = currentUser.value?.id || currentUser.value?.sub
  return order.waiterId === uid
})

const companyId = computed(() => currentUser.value?.companyId || currentUser.value?.company_id || null)
const branchId = computed(() => currentUser.value?.branchId || currentUser.value?.branch_id || null)
const companyName = computed(() => currentUser.value?.company?.name || '')
  
const departments = ref([])
const menus = ref([])
const searchTerm = ref('')
const selectedDept = ref(null)
const selectedSub = ref(null)

// Toast notification state
const toast = ref({ show: false, message: '', type: 'success' })

// Toast helper function
function showToast(message, type = 'success', duration = 3000) {
  toast.value = { show: true, message, type }
  setTimeout(() => {
    toast.value.show = false
  }, duration)
}

function isStatusOn(v) {
  if (v === undefined || v === null) return false
  if (v === 1 || v === true) return true
  if (typeof v === 'string') return v.toLowerCase() === 'on' || v === '1' || v.toLowerCase() === 'active'
  if (typeof v === 'number') return v === 1
  return false
}

async function loadDepartments() {
  if (!companyId.value) {
    alert('Company ID not found in user profile.')
    return
  }

  try {
    let endpoint = `/departments/company/${companyId.value}`
    if (branchId.value) {
      endpoint = `/departments/branch/${branchId.value}`
    }
    
    const response = await apiFetch(endpoint, { method: 'GET' })
    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      throw new Error(data.message || 'Failed to load departments')
    }
    const data = await response.json()
    // POS: Only show active departments (status ON/1) that have printerIP.
    // Also filter subDepartments by active status if present.
    departments.value = (Array.isArray(data) ? data : [])
      .filter(d => d?.printerIP)
      .filter(d => isStatusOn(d?.status ?? d?.isActive ?? d?.is_active))
      .map(d => ({
        ...d,
        subDepartments: Array.isArray(d?.subDepartments)
          ? d.subDepartments
              .filter(sd => isStatusOn(sd?.status ?? sd?.isActive ?? sd?.is_active))
              .slice()
              .sort((a, b) => (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' }))
          : d?.subDepartments
      }))
    departments.value = departments.value
      .filter(d => d.status === 1)
      .slice()
      .sort((a, b) => (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' }))
    // console.log('POS departments loaded (filtered by printerIP):', departments.value)
  } catch (err) {
    alert(err.message || 'Failed to load departments')
  } 
}

// Load all menus once, filtered by company/branch (backend: /menu-lists)
async function loadMenus() {
  if (!companyId.value && !branchId.value) return
  try {
    const params = new URLSearchParams()
    if (branchId.value) params.append('branchId', branchId.value)
    else if (companyId.value) params.append('companyId', companyId.value)

    const response = await apiFetch(`/menu-lists?${params.toString()}`, { method: 'GET' })
    if (!response.ok) {
      console.error('Failed to load menus')
      return
    }
    const data = await response.json().catch(() => [])
    const list = Array.isArray(data) ? data : []
    menus.value = list.map((m) => {
      const totalPrice = Number(m.totalPrice ?? m.total_price ?? 0) || 0
      const originalPrice = Number(m.price ?? 0) || 0
      const addition = Number(m.addition ?? 0) || 0
      const vat = Number(m.vat ?? 0) || 0
      return {
        ...m,
        totalPrice,
        total_price: totalPrice,
        price: originalPrice,
        addition,
        vat
      }
    })
  } catch (err) {
    console.error('Error loading menus:', err)
  }
}

onMounted(() => {
  loadDepartments()
  loadMenus()
  loadPaymentMethods()
  loadDeliveryCompanies()
  loadTableMandatorySetting()
})
const billItems = ref([])
const printFailures = ref([])
const tableNumber = ref('')
const tableError = ref(false)
const isTableMandatory = ref(1)
const orders = ref([])
const viewMode = ref('bill') // 'bill' or 'orders'
const hoveredAllOrder = ref(null)
const hoveredAllOrderEl = ref(null)
const hoveredAllOrderStyle = ref({ top: '0px', left: '0px', transform: 'translateX(-100%)' })
const currentEditingOrderId = ref(null)
const editingOrderUpdatedAt = ref([])
const originalWaiterId = ref(null)
const selectedWaiter = ref('')
const selectedOrderDate = ref('')
const isDelivery = ref(false)
const deliveryCompany = ref('')
const deliveryCode = ref('')
const deliveryCompanies = ref([])

const showPaymentModal = ref(false)
const paymentPhase = ref('selection') // 'selection' or 'details'
const paymentModalPurpose = ref('confirm') // 'confirm' | 'scan'
const billContainer = ref(null)

function scrollToBottom() {
  if (billContainer.value) {
    billContainer.value.scrollTop = billContainer.value.scrollHeight
  }
}
const paymentMethods = ref([])

const availablePaymentMethods = computed(() => {
  if (!isDelivery.value || !deliveryCompany.value) {
    return paymentMethods.value.filter(m => m.name.toLowerCase() !== 'delivery')
  }
  return paymentMethods.value
})

const modalPaymentMethods = computed(() => {
  if (paymentModalPurpose.value === 'scan') {
    return paymentMethods.value.filter((method) => {
      const name = (method.name || '').toLowerCase()
      return name !== 'cash' && name !== 'delivery'
    })
  }
  return availablePaymentMethods.value
})

async function loadPaymentMethods() {
  try {
    const res = await apiFetch('/settings/payment-methods')
    if (res.ok) {
      const data = await res.json()
      // Keep upload paths normalized so LAN/mobile clients can resolve them via /uploads.
      paymentMethods.value = data.filter(m => m.isActive === 1).map((method) => ({
        ...method,
        logo: normalizeUploadValue(method.logo),
      }))
    }
  } catch (err) {
    console.error('Error loading payment methods:', err)
  }
}

async function loadDeliveryCompanies() {
  try {
    const res = await apiFetch('/settings/delivery-companies')
    if (res.ok) {
      const data = await res.json()
      // Only show active delivery companies
      deliveryCompanies.value = data.filter(c => c.isActive === 1)
    }
  } catch (err) {
    console.error('Error loading delivery companies:', err)
  }
}

function resolveDeliveryCompanySelection(raw) {
  if (raw == null || raw === '') return ''
  const value = String(raw)
  const byId = deliveryCompanies.value.find(c => String(c.id) === value)
  if (byId) return String(byId.id)
  const byName = deliveryCompanies.value.find(c => c.name === value)
  if (byName) return String(byName.id)
  return value
}

async function loadTableMandatorySetting() {
  try {
    const res = await apiFetch('/settings')
    if (!res.ok) return
    const data = await res.json()
    isTableMandatory.value = Number(data?.is_table_mandatory ?? 1) === 1 ? 1 : 0
  } catch (err) {
    console.error('Failed to read table mandatory setting:', err)
  }
}

const selectedPaymentMethod = ref(null)
const customerPhone = ref('')
const transactionId = ref('')
const scannedReceiverDisplay = ref('')
const scannedCbeToken = ref('')
const cbeQrStatus = ref('') // '' | 'loading' | 'success' | 'error'
const cbeQrStatusMessage = ref('')

const showTxnScanModal = ref(false)
const showTxnScanSourcePicker = ref(false)
const showTxnLiveCameraScan = ref(false)
const isScanningTransaction = ref(false)
const txnLiveScanProcessing = ref(false)
const txnLiveScanPurpose = ref('ocr')
const txnScanMode = ref('chooser')
const txnScanFileInput = ref(null)
const txnScanCameraInput = ref(null)
const txnScanVideo = ref(null)
const txnLiveScanVideo = ref(null)
let txnScanCameraStream = null
let tesseractWorker = null
let txnLiveScanTimer = null
let txnLiveScanBusy = false
let txnPendingQrDecode = false
let txnQrScanRafId = null
let jsQrModule = null
let txnBarcodeDetector = null
let cbeZxingReader = null
let cbeZxingControls = null
let cbeQrLookupInFlight = false
let hostedCbeScannerWindow = null
const HOSTED_CBE_SCANNER_ORIGIN = 'https://theminasoft.com'

const isCbePaymentSelected = computed(() => isCbeMethod(normalizePaymentMethodName(selectedPaymentMethod.value)))
const isTelebirrPaymentSelected = computed(() => isTelebirrMethod(normalizePaymentMethodName(selectedPaymentMethod.value)))

const TELEBIRR_RECEIVER_PHONE = '0911111111'

const TXN_VALUE_NOISE = /^(?:transaction\s+)?(?:successful|success|complete|completed|failed|pending|approved|paid|sent|received|processed)\b/i
const INVALID_TXN_VALUES = new Set([
  'successful', 'success', 'completed', 'complete', 'failed', 'pending',
  'approved', 'paid', 'sent', 'received', 'processed', 'telebirr', 'cbe',
  'number', 'amount', 'date', 'time', 'total', 'balance', 'etb', 'birr',
  'utility', 'payment', 'electricity', 'ethiopian', 'finished', 'transfer',
  'commercial', 'bank', 'reason', 'debit', 'credit', 'charge', 'vat',
])

const TELEBIRR_TXN_NUMBER_PATTERNS = [
  /transac[tlo1i0n]+\s+num[b8o0]?[e3a]?r\.?\s*[:-]?\s*([A-Z0-9]{8,12})\b/gi,
  /txn\s+num[b8o0]?[e3a]?r\.?\s*[:-]?\s*([A-Z0-9]{8,12})\b/gi,
]

const CBE_TXN_ID_PATTERNS = [
  /(?:with\s+)?transaction\s*[i1l|]?\s*d\s*[:-]?\s*(FT[A-Z0-9]{8,16})\b/gi,
  /transaction\s*[i1l|]?\s*d\s*[:-]?\s*(FT[A-Z0-9]{8,16})\b/gi,
  /\bID\s*:\s*(FT[A-Z0-9]{8,16})\b/gi,
  /txn\s*[i1l|]?\s*d\s*[:-]?\s*(FT[A-Z0-9]{8,16})\b/gi,
  /\b(FT[A-Z0-9]{8,16})\b/g,
]

function normalizePaymentMethodName(method) {
  return String(method?.name || method || '').trim().toLowerCase()
}

function isTelebirrMethod(name) {
  return /tele\s*birr|telebirr|telet\s*birr/i.test(name)
}

function isCbeMethod(name) {
  return /\bcbe\b|commercial\s*bank|bank\s*of\s*ethiopia/i.test(name)
}

function buildTxnLabelConfig(term) {
  const flexibleTerm = term.replace(/\\s\+/g, '\\s*')
  return {
    label: new RegExp(flexibleTerm, 'i'),
  }
}

function getTxnLabelConfigs(paymentMethod) {
  const name = normalizePaymentMethodName(paymentMethod)
  if (isTelebirrMethod(name)) {
    return [
      'transac[tlo1i0n]+\\s+num[b8o0]?[e3a]?r',
      'transaction\\s+num[b8]er',
      'transaction\\s+no\\.?(?!\\w)',
      'txn\\s+num[b8]er',
      'txn\\s+no\\.?(?!\\w)',
    ].map(buildTxnLabelConfig)
  }
  if (isCbeMethod(name)) {
    return [
      'with\\s+transaction\\s+[i1l|]\\s*d',
      'transaction\\s+[i1l|]\\s*d',
      'transaction\\s+id',
      'transactionid',
      'txn\\s+[i1l|]\\s*d',
      'txn\\s+id',
    ].map(buildTxnLabelConfig)
  }
  return [
    'transaction\\s+number', 'transaction\\s+id', 'transaction\\s+no',
    'reference\\s+number', 'reference\\s+id', 'reference\\s+no',
    'ref\\.?\\s+no', 'ref\\.?\\s+number', 'ref\\.?\\s+id',
    'receipt\\s+number', 'receipt\\s+no', 'receipt\\s+id',
    'trace\\s+number', 'trace\\s+no', 'trace\\s+id',
    'txn\\s+id', 'txn\\s+number', 'txn\\s+no',
  ].map(buildTxnLabelConfig)
}

function normalizeOcrText(ocrText) {
  return String(ocrText || '')
    .replace(/\u00A0/g, ' ')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/[：﹕；]/g, ':')
    .replace(/[|¦]/g, ' ')
    .replace(/\r/g, '\n')
}

function collapseOcrText(text) {
  return normalizeOcrText(text).replace(/\s+/g, ' ').trim()
}

function cleanTxnId(value) {
  return String(value || '').trim().replace(/[^\w-]/g, '')
}

function isValidTxnValue(value) {
  const cleaned = cleanTxnId(value)
  if (!cleaned || cleaned.length < 4) return false
  if (INVALID_TXN_VALUES.has(cleaned.toLowerCase())) return false
  if (/^\d{1,2}$/.test(cleaned)) return false
  return true
}

function isValidTelebirrTxnValue(value) {
  const cleaned = cleanTxnId(value).toUpperCase()
  if (!isValidTxnValue(cleaned)) return false
  if (/^FT[A-Z0-9]{6,}$/.test(cleaned)) return false
  if (!/^[A-Z0-9]{8,12}$/.test(cleaned)) return false
  if (!/[A-Z]/.test(cleaned) || !/[0-9]/.test(cleaned)) return false
  return true
}

function isTxnIdValidForPaymentMethod(txnId, paymentMethod) {
  const cleaned = cleanTxnId(txnId).toUpperCase()
  if (!cleaned) return false
  const name = normalizePaymentMethodName(paymentMethod)
  if (isTelebirrMethod(name)) return isValidTelebirrTxnValue(cleaned)
  if (isCbeMethod(name)) return isValidCbeTxnValue(cleaned)
  return isValidTxnValue(cleaned)
}

function detectPaymentScreenshotMismatch(ocrText, paymentMethod) {
  const name = normalizePaymentMethodName(paymentMethod)
  const collapsed = collapseOcrText(ocrText)
  if (!collapsed) return ''

  const hasTelebirrMarkers = /tele\s*birr|telebirr|telet\s*birr/i.test(collapsed) ||
    /(?:transac|txn)\s+num[b8]/i.test(collapsed)
  const hasCbeMarkers = /\b(?:cbe|commercial\s*bank|bank\s*of\s*ethiopia)\b/i.test(collapsed) ||
    /transaction\s*[i1l|]?\s*d\s*[:-]?\s*FT/i.test(collapsed) ||
    /\bFT[A-Z0-9]{8,16}\b/i.test(collapsed)

  if (isTelebirrMethod(name) && hasCbeMarkers && !hasTelebirrMarkers) {
    return 'This image looks like a CBE payment screenshot. Please upload a Telebirr confirmation.'
  }
  if (isCbeMethod(name) && hasTelebirrMarkers && !hasCbeMarkers) {
    return 'This image looks like a Telebirr payment screenshot. Please upload a CBE confirmation.'
  }
  return ''
}

function isValidCbeTxnValue(value) {
  const cleaned = cleanTxnId(value).toUpperCase()
  if (!isValidTxnValue(cleaned)) return false
  return /^FT[A-Z0-9]{8,16}$/.test(cleaned)
}

function pickTelebirrTxnCandidate(text) {
  if (!text || TXN_VALUE_NOISE.test(text)) return ''
  const tokens = String(text).match(/\b[A-Z0-9]{8,12}\b/gi) || []
  const valid = tokens.map((token) => cleanTxnId(token).toUpperCase()).filter(isValidTelebirrTxnValue)
  if (!valid.length) return ''
  return valid.sort((a, b) => {
    const aLetters = (a.match(/[A-Z]/g) || []).length
    const bLetters = (b.match(/[A-Z]/g) || []).length
    if (aLetters !== bLetters) return bLetters - aLetters
    return b.length - a.length
  })[0]
}

function pickCbeTxnCandidate(text) {
  if (!text || TXN_VALUE_NOISE.test(text)) return ''
  const tokens = String(text).match(/\bFT[A-Z0-9]{8,16}\b/gi) || []
  const valid = tokens.map((token) => cleanTxnId(token).toUpperCase()).filter(isValidCbeTxnValue)
  if (!valid.length) return ''
  return valid.sort((a, b) => b.length - a.length)[0]
}

function pickBestTxnCandidate(text, paymentMethod = null) {
  if (!text || TXN_VALUE_NOISE.test(text)) return ''
  const name = normalizePaymentMethodName(paymentMethod)
  if (isTelebirrMethod(name)) return pickTelebirrTxnCandidate(text)
  if (isCbeMethod(name)) return pickCbeTxnCandidate(text)

  const tokens = String(text).match(/[A-Za-z0-9][A-Za-z0-9-]{2,}/g) || []
  const valid = tokens.map(cleanTxnId).filter(isValidTxnValue)
  if (!valid.length) return ''
  return valid.sort((a, b) => b.length - a.length)[0]
}

function cleanReceiverName(name) {
  return String(name || '')
    .replace(/\s+/g, ' ')
    .replace(/^[:.\-\s]+/, '')
    .replace(/[:.\-\s]+$/, '')
    .trim()
}

function extractCbeReceiverDisplay(ocrText) {
  if (!ocrText) return ''
  const collapsed = collapseOcrText(ocrText)
  const accountToken = '(?:ETB|EIB|ET8)\\s*[\\-:]?\\s*(\\d{4})'
  const patterns = [
    new RegExp(`\\bfor\\s+([A-Za-z][A-Za-z0-9&.,'/\\- ]{2,80}?)\\s+${accountToken}\\s+on\\b`, 'i'),
    new RegExp(`debited\\s+from\\s+.+?\\s+${accountToken}\\s+for\\s+([A-Za-z][A-Za-z0-9&.,'/\\- ]{2,80}?)\\s+${accountToken}\\b`, 'i'),
  ]

  const first = collapsed.match(patterns[0])
  if (first?.[1] && first?.[2]) {
    const name = cleanReceiverName(first[1])
    if (name) return `${name} ETB-${first[2]}`
  }

  const second = collapsed.match(patterns[1])
  if (second?.[2] && second?.[3]) {
    const name = cleanReceiverName(second[2])
    if (name) return `${name} ETB-${second[3]}`
  }
  return ''
}

const TELEBIRR_RECEIVER_LABEL_RE = /trans(?:fer|action|ac[tlo1i0n]+)\s+(?:to|t0)\b/i
const TELEBIRR_RECEIVER_LABEL_STRIP_RE = /trans(?:fer|action|ac[tlo1i0n]+)\s+(?:to|t0)\s*[:-]?\s*/i
const TELEBIRR_RECEIVER_LABEL_ONLY_RE = /^trans(?:fer|action|ac[tlo1i0n]+)\s+(?:to|t0)\s*[:-]?\s*$/i
const TELEBIRR_RECEIVER_STOP_RE = /\b(?:transaction\s+(?:number|num|type|time)|txn\s+num|contract|customer|recharge)\b/i
const TELEBIRR_RECEIVER_BEFORE_NUMBER_RE = /trans(?:fer|action|ac[tlo1i0n]+)\s+(?:to|t0)\s*[:-]?\s*(.+?)(?=\s+trans(?:fer|action|ac[tlo1i0n]+)\s+(?:number|num)\b)/i
const TELEBIRR_FIELD_LABEL_RE = /^(?:trans(?:fer|action|ac[tlo1i0n]+)\s+(?:time|type|to|t0|number|num)|contract\s+account\s+number|customer\s+name|recharge\s+token)\b\s*[:-]?\s*$/i

function isTelebirrReceiverTypeLine(line) {
  return /trans(?:fer|action|ac[tlo1i0n]+)\s+type\b/i.test(collapseOcrText(line))
}

function isTelebirrPureFieldLabelLine(line) {
  return TELEBIRR_FIELD_LABEL_RE.test(collapseOcrText(line))
}

function parseTelebirrReceiverNameCandidate(raw) {
  if (!raw) return ''
  const segment = String(raw).split(TELEBIRR_RECEIVER_STOP_RE)[0]
  const name = cleanReceiverName(segment)
  if (!name) return ''
  if (/^(?:type|time|number|num|transaction|txn|transfer)\b/i.test(name)) return ''
  if (/^\d{4}[-/]\d{2}[-/]\d{2}/.test(name)) return ''
  return name
}

function formatTelebirrReceiverDisplay(name) {
  const cleaned = cleanReceiverName(name)
  if (!cleaned) return ''
  return `Transaction To: ${cleaned} ${TELEBIRR_RECEIVER_PHONE}`
}

function extractTelebirrReceiverFromColumnarLayout(lines) {
  const collapsedLines = lines.map((line) => collapseOcrText(line))
  let receiverLabelIdx = -1

  for (let i = 0; i < collapsedLines.length; i++) {
    if (!isTelebirrReceiverLabelLine(lines[i])) continue

    const inline = parseTelebirrReceiverNameCandidate(
      collapsedLines[i].replace(TELEBIRR_RECEIVER_LABEL_STRIP_RE, '').trim()
    )
    if (inline) return inline

    if (TELEBIRR_RECEIVER_LABEL_ONLY_RE.test(collapsedLines[i]) ||
      !collapsedLines[i].replace(TELEBIRR_RECEIVER_LABEL_STRIP_RE, '').trim()) {
      receiverLabelIdx = i
      break
    }
  }

  if (receiverLabelIdx < 0) return ''

  if (receiverLabelIdx + 1 < lines.length && !isTelebirrPureFieldLabelLine(lines[receiverLabelIdx + 1])) {
    const name = parseTelebirrReceiverNameCandidate(collapsedLines[receiverLabelIdx + 1])
    if (name) return name
  }

  let blockStart = receiverLabelIdx
  while (blockStart > 0 && isTelebirrPureFieldLabelLine(lines[blockStart - 1])) {
    blockStart--
  }

  let blockEnd = receiverLabelIdx
  while (blockEnd + 1 < lines.length && isTelebirrPureFieldLabelLine(lines[blockEnd + 1])) {
    blockEnd++
  }

  const receiverOffset = receiverLabelIdx - blockStart
  let valueStart = blockEnd + 1
  while (valueStart < lines.length && isTelebirrPureFieldLabelLine(lines[valueStart])) {
    valueStart++
  }

  const valueIdx = valueStart + receiverOffset
  if (valueIdx < lines.length && !isTelebirrPureFieldLabelLine(lines[valueIdx])) {
    const name = parseTelebirrReceiverNameCandidate(collapsedLines[valueIdx])
    if (name) return name
  }

  return ''
}

function isTelebirrReceiverLabelLine(line) {
  const collapsed = collapseOcrText(line)
  if (isTelebirrReceiverTypeLine(line)) return false
  return TELEBIRR_RECEIVER_LABEL_RE.test(collapsed)
}

function extractTelebirrReceiverDisplay(ocrText) {
  if (!ocrText) return ''
  const collapsed = collapseOcrText(ocrText)

  const beforeNumber = collapsed.match(TELEBIRR_RECEIVER_BEFORE_NUMBER_RE)
  if (beforeNumber?.[1]) {
    const name = parseTelebirrReceiverNameCandidate(beforeNumber[1])
    if (name) return formatTelebirrReceiverDisplay(name)
  }

  const sameLine = collapsed.match(
    /trans(?:fer|action|ac[tlo1i0n]+)\s+(?:to|t0)\s*[:-]?\s*([A-Za-z][A-Za-z0-9&.,'/\- ]{1,80}?)(?=\s+(?:transaction\s+(?:number|num|type|time)|txn\s+num|contract|customer|recharge)\b|$)/i
  )
  if (sameLine?.[1]) {
    const name = parseTelebirrReceiverNameCandidate(sameLine[1])
    if (name) return formatTelebirrReceiverDisplay(name)
  }

  const lines = normalizeOcrText(ocrText).split(/\n+/).map((line) => line.trim()).filter(Boolean)
  for (let i = 0; i < lines.length; i++) {
    const line = collapseOcrText(lines[i])
    if (!isTelebirrReceiverLabelLine(lines[i])) continue

    const inline = parseTelebirrReceiverNameCandidate(line.replace(TELEBIRR_RECEIVER_LABEL_STRIP_RE, '').trim())
    if (inline) return formatTelebirrReceiverDisplay(inline)

    const isLabelOnly = TELEBIRR_RECEIVER_LABEL_ONLY_RE.test(line) ||
      !line.replace(TELEBIRR_RECEIVER_LABEL_STRIP_RE, '').trim()

    if (isLabelOnly && i + 1 < lines.length && !isTelebirrPureFieldLabelLine(lines[i + 1])) {
      const name = parseTelebirrReceiverNameCandidate(collapseOcrText(lines[i + 1]))
      if (name) return formatTelebirrReceiverDisplay(name)
    }
  }

  const columnarName = extractTelebirrReceiverFromColumnarLayout(lines)
  if (columnarName) return formatTelebirrReceiverDisplay(columnarName)

  return ''
}

function extractScannedReceiverDisplay(ocrText, paymentMethod = null) {
  const name = normalizePaymentMethodName(paymentMethod)
  if (isCbeMethod(name)) return extractCbeReceiverDisplay(ocrText)
  if (isTelebirrMethod(name)) return extractTelebirrReceiverDisplay(ocrText)
  return ''
}

function applyExtractedPaymentScan(extracted, receiverDisplay = '') {
  transactionId.value = extracted
  scannedReceiverDisplay.value = receiverDisplay || ''
}

function handleHostedCbeScannerMessage(event) {
  if (event.origin !== HOSTED_CBE_SCANNER_ORIGIN || event.source !== hostedCbeScannerWindow) return
  if (event.data?.type !== 'cbe-qr-result') return
  const result = event.data
  const scannedId = String(result.transactionId || '').trim()
  if (!scannedId) return
  applyExtractedPaymentScan(scannedId, result.receiverDisplay || buildCbeScanReceiverDisplay(result))
  scannedCbeToken.value = ''
  cbeQrStatus.value = 'success'
  cbeQrStatusMessage.value = 'Scanned Successfully!'
  hostedCbeScannerWindow?.close?.()
  hostedCbeScannerWindow = null
}

function openHostedCbeScanner() {
  if (hostedCbeScannerWindow && !hostedCbeScannerWindow.closed) {
    hostedCbeScannerWindow.focus()
    return
  }
  const returnOrigin = window.location.origin
  if (!/^https?:$/.test(window.location.protocol) || !returnOrigin) {
    showToast('The hosted CBE scanner needs the POS opened over HTTP.', 'error')
    return
  }
  const params = new URLSearchParams({ returnOrigin })
  hostedCbeScannerWindow = window.open(
    `${HOSTED_CBE_SCANNER_ORIGIN}/qr-scanner?${params.toString()}`,
    'cbeQrScanner',
    'popup=yes,width=520,height=760,resizable=yes,scrollbars=yes',
  )
  if (!hostedCbeScannerWindow) showToast('Please allow the CBE scanner popup.', 'error')
}

function extractValueAfterLabel(text, label, paymentMethod = null) {
  const collapsed = collapseOcrText(text)
  const match = collapsed.match(label)
  if (!match || match.index == null) return ''
  const after = collapsed.slice(match.index + match[0].length)
  const remainder = after.replace(/^[\s:.#|=-]+/, '').trim()
  if (!remainder) return ''
  return pickBestTxnCandidate(remainder, paymentMethod)
}

function extractTelebirrStandaloneLines(ocrText) {
  const lines = normalizeOcrText(ocrText).split(/\n+/).map((line) => line.trim()).filter(Boolean)
  const candidates = []

  for (const line of lines) {
    const cleaned = cleanTxnId(line).toUpperCase()
    if (!isValidTelebirrTxnValue(cleaned)) continue
    if (cleaned !== collapseOcrText(line).replace(/\s+/g, '').toUpperCase()) continue
    candidates.push(cleaned)
  }

  if (!candidates.length) return ''

  const unique = [...new Set(candidates)]
  const score = (id) => {
    let points = 0
    if (id.length >= 9 && id.length <= 11) points += 3
    if (/[A-Z]{2,}/.test(id) && /[0-9]{2,}/.test(id)) points += 4
    if (/^[A-Z]{2,}[0-9][A-Z0-9]*$/.test(id)) points += 2
    return points
  }

  unique.sort((a, b) => score(b) - score(a))
  return unique[0]
}

function extractTelebirrTransactionId(ocrText) {
  if (!ocrText) return ''
  const collapsed = collapseOcrText(ocrText)

  for (const pattern of TELEBIRR_TXN_NUMBER_PATTERNS) {
    const regex = new RegExp(pattern.source, pattern.flags)
    let match = regex.exec(collapsed)
    while (match) {
      const candidate = cleanTxnId(match[1]).toUpperCase()
      if (isValidTelebirrTxnValue(candidate)) return candidate
      match = regex.exec(collapsed)
    }
  }

  const lines = normalizeOcrText(ocrText).split(/\n+/).map((line) => line.trim()).filter(Boolean)
  for (let i = 0; i < lines.length; i++) {
    const line = collapseOcrText(lines[i])
    if (!/(?:transac|txn)/i.test(line) || !/num/i.test(line)) continue

    const inline = line.match(/(?:transac[tlo1i0n]+|txn)\s+num[b8o0]?[e3a]?r\.?\s*[:-]?\s*([A-Z0-9]{8,12})\b/i)
    if (inline?.[1] && isValidTelebirrTxnValue(inline[1])) {
      return cleanTxnId(inline[1]).toUpperCase()
    }

    for (let j = 1; j <= 3 && i + j < lines.length; j++) {
      const candidate = pickTelebirrTxnCandidate(lines[i + j])
      if (candidate) return candidate
    }
  }

  const standalone = extractTelebirrStandaloneLines(ocrText)
  if (standalone) return standalone

  if (/tele\s*birr|telebirr|(?:transac|txn)\s+num/i.test(collapsed)) {
    return pickTelebirrTxnCandidate(collapsed)
  }
  return ''
}

function extractCbeTransactionId(ocrText) {
  if (!ocrText) return ''
  const collapsed = collapseOcrText(ocrText)

  for (const pattern of CBE_TXN_ID_PATTERNS) {
    const regex = new RegExp(pattern.source, pattern.flags)
    let match = regex.exec(collapsed)
    while (match) {
      const candidate = cleanTxnId(match[1] || match[0]).toUpperCase()
      if (isValidCbeTxnValue(candidate)) return candidate
      match = regex.exec(collapsed)
    }
  }

  const lines = normalizeOcrText(ocrText).split(/\n+/).map((line) => line.trim()).filter(Boolean)
  for (let i = 0; i < lines.length; i++) {
    const line = collapseOcrText(lines[i])

    const idLine = line.match(/^\s*ID\s*:\s*(FT[A-Z0-9]{8,16})\b/i)
    if (idLine?.[1] && isValidCbeTxnValue(idLine[1])) {
      return cleanTxnId(idLine[1]).toUpperCase()
    }

    if (/transaction/i.test(line)) {
      const inline = line.match(/(?:with\s+)?transaction\s*[i1l|]?\s*d\s*[:-]?\s*(FT[A-Z0-9]{8,16})\b/i)
      if (inline?.[1] && isValidCbeTxnValue(inline[1])) {
        return cleanTxnId(inline[1]).toUpperCase()
      }

      for (let j = 1; j <= 2 && i + j < lines.length; j++) {
        const nextLine = collapseOcrText(lines[i + j])
        const splitId = nextLine.match(/^\s*ID\s*:\s*(FT[A-Z0-9]{8,16})\b/i)
        if (splitId?.[1] && isValidCbeTxnValue(splitId[1])) {
          return cleanTxnId(splitId[1]).toUpperCase()
        }
        const candidate = pickCbeTxnCandidate(lines[i + j])
        if (candidate) return candidate
      }
    }
  }

  return pickCbeTxnCandidate(collapsed)
}

function extractTransactionIdFromOcrText(ocrText, paymentMethod = null) {
  if (!ocrText) return ''
  const name = normalizePaymentMethodName(paymentMethod)

  if (isTelebirrMethod(name)) {
    const telebirrId = extractTelebirrTransactionId(ocrText)
    if (telebirrId) return telebirrId
  }
  if (isCbeMethod(name)) {
    const cbeId = extractCbeTransactionId(ocrText)
    if (cbeId) return cbeId
  }

  const labelConfigs = getTxnLabelConfigs(paymentMethod)
  const normalized = normalizeOcrText(ocrText)
  const lines = normalized.split(/\n+/).map((line) => line.trim()).filter(Boolean)
  const collapsedAll = collapseOcrText(normalized)

  const searchTexts = [collapsedAll, ...lines.map(collapseOcrText)]
  for (let i = 0; i < lines.length - 1; i++) {
    searchTexts.push(collapseOcrText(`${lines[i]} ${lines[i + 1]}`))
    if (i + 2 < lines.length) {
      searchTexts.push(collapseOcrText(`${lines[i]} ${lines[i + 1]} ${lines[i + 2]}`))
    }
  }

  for (const text of searchTexts) {
    for (const { label } of labelConfigs) {
      const found = extractValueAfterLabel(text, label, paymentMethod)
      if (found) return found
    }
  }

  for (let i = 0; i < lines.length; i++) {
    for (const { label } of labelConfigs) {
      if (!label.test(collapseOcrText(lines[i]))) continue
      for (let j = 1; j <= 3 && i + j < lines.length; j++) {
        const candidate = pickBestTxnCandidate(lines[i + j], paymentMethod)
        if (candidate) return candidate
      }
    }
  }

  return ''
}

function getTxnScanErrorMessage(paymentMethod) {
  const name = normalizePaymentMethodName(paymentMethod)
  if (isTelebirrMethod(name)) {
    return 'Could not find Transaction Number in the image. Try a clearer screenshot.'
  }
  if (isCbeMethod(name)) {
    return 'Could not find Transaction ID in the image. Try a clearer screenshot.'
  }
  return 'Could not find a transaction reference in the image. Try a clearer screenshot.'
}

function getTxnQrScanErrorMessage(paymentMethod) {
  const name = normalizePaymentMethodName(paymentMethod)
  if (isCbeMethod(name)) {
    return 'Could not find a valid CBE receipt QR. Expected a CBE receipt URL.'
  }
  return 'Could not find a transaction reference in QR code.'
}

function resetCbeQrScanState() {
  scannedCbeToken.value = ''
  cbeQrStatus.value = ''
  cbeQrStatusMessage.value = ''
  cbeQrLookupInFlight = false
}

function formatCbeScanAmount(amount) {
  if (amount == null || amount === '') return ''
  const raw = String(amount).trim()
  if (!raw) return ''
  const numeric = Number(String(raw).replace(/,/g, '').replace(/[^\d.-]/g, ''))
  if (Number.isFinite(numeric)) {
    return numeric.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }
  return raw
}

function formatCbeScanTransactionDate(value) {
  if (value == null || value === '') return ''
  const raw = String(value).trim()
  if (!raw) return ''
  const parsed = new Date(raw)
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleString([], {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  }
  return raw
}

function buildCbeScanReceiverDisplay(result = {}) {
  const lines = [
    result.receiverName ? `Receiver: ${result.receiverName}` : '',
    result.amount ? `Amount: ${formatCbeScanAmount(result.amount)}` : '',
    result.receiverAccountLast4 ? `Account: ****${result.receiverAccountLast4}` : '',
    result.transactionDate ? `Transaction Date: ${formatCbeScanTransactionDate(result.transactionDate)}` : '',
  ].filter(Boolean)
  return lines.join('\n')
}

function extractCbeReceiptToken(content) {
  if (!content) return ''
  const text = String(content).trim()
  if (!text) return ''

  const tryFromUrl = (raw) => {
    try {
      const url = new URL(raw)
      const host = String(url.hostname || '').toLowerCase()
      if (!host.includes('cbe.com.et')) return ''
      const pathParts = String(url.pathname || '')
        .split('/')
        .map((part) => part.trim())
        .filter(Boolean)
      if (pathParts.length) return normalizeCbeReceiptToken(decodeURIComponent(pathParts[pathParts.length - 1]))
      const idParam = url.searchParams.get('id') || url.searchParams.get('token')
      if (idParam) return normalizeCbeReceiptToken(decodeURIComponent(String(idParam).trim()))
    } catch (_) {
      return ''
    }
    return ''
  }

  const fromUrl = tryFromUrl(text)
  if (fromUrl) return fromUrl

  const receiptMatch = text.match(/https?:\/\/[^\s]*cbe\.com\.et[^\s]*/i)
  if (receiptMatch?.[0]) {
    const nested = tryFromUrl(receiptMatch[0])
    if (nested) return normalizeCbeReceiptToken(nested)
  }

  const pathMatch = text.match(/mbrecie?pt\.cbe\.com\.et\/([A-Za-z0-9._-]+)/i)
  if (pathMatch?.[1]) return normalizeCbeReceiptToken(pathMatch[1])

  return ''
}

function normalizeCbeReceiptToken(token) {
  return String(token || '').trim().replace(/^v2-/i, '')
}

function extractCbeReceiptUrl(content) {
  const text = String(content || '').trim()
  if (!text) return ''
  const candidate = text.match(/https?:\/\/[^\s]+/i)?.[0] || text
  try {
    const url = new URL(candidate.replace(/[),.;]+$/, ''))
    if (url.protocol !== 'https:' || url.hostname.toLowerCase() !== 'mbreciept.cbe.com.et') return ''
    return url.toString()
  } catch (_) {
    return ''
  }
}

async function fetchCbeTransactionIdByToken(token) {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 15000)
  try {
    const res = await apiFetch(`/cbe/${encodeURIComponent(token)}`, {
      method: 'GET',
      signal: controller.signal,
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      throw new Error(data.message || `Failed to fetch CBE transaction (${res.status})`)
    }
    const txnId = String(data.transactionId || data.reference || data.vatReceiptNo || '').trim()
    if (!txnId) throw new Error('CBE response did not include a transaction ID')
    return {
      transactionId: txnId,
      token,
      reference: data.reference || '',
      vatReceiptNo: data.vatReceiptNo || '',
      receiverName: data.receiverName || '',
      receiverAccountLast4: data.receiverAccountLast4 || '',
      amount: data.amount || '',
      transactionDate: data.transactionDate || '',
    }
  } catch (err) {
    if (err?.name === 'AbortError') {
      throw new Error('CBE request timed out. Please try again.')
    }
    throw err
  } finally {
    clearTimeout(timeoutId)
  }
}

async function fetchCbeTransactionFromReceiptUrl(receiptUrl) {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 15000)
  try {
    const res = await apiFetch('/cbe/receipt', {
      method: 'POST',
      signal: controller.signal,
      body: JSON.stringify({ url: receiptUrl }),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) throw new Error(data.message || `Failed to read CBE receipt (${res.status})`)
    const transactionId = String(data.transactionId || data.reference || data.vatReceiptNo || '').trim()
    if (!transactionId) throw new Error('CBE receipt did not include a Transaction ID')
    return {
      transactionId,
      token: extractCbeReceiptToken(receiptUrl),
      reference: data.reference || '',
      vatReceiptNo: data.vatReceiptNo || '',
      receiverName: data.receiverName || '',
      receiverAccountLast4: data.receiverAccountLast4 || '',
      amount: data.amount || '',
      transactionDate: data.transactionDate || '',
    }
  } catch (err) {
    if (err?.name === 'AbortError') throw new Error('CBE receipt request timed out. Please try again.')
    throw err
  } finally {
    clearTimeout(timeoutId)
  }
}

async function resolveCbeTransactionFromQrContent(qrContent) {
  if (cbeQrLookupInFlight) return null

  const receiptUrl = extractCbeReceiptUrl(qrContent)
  const token = extractCbeReceiptToken(receiptUrl || qrContent)
  if (!token) {
    throw new Error(getTxnQrScanErrorMessage(selectedPaymentMethod.value))
  }

  cbeQrLookupInFlight = true
  isScanningTransaction.value = true
  scannedCbeToken.value = token
  cbeQrStatus.value = 'loading'
  cbeQrStatusMessage.value = 'Fetching Transaction ID from CBE...'

  try {
    const result = receiptUrl
      ? await fetchCbeTransactionFromReceiptUrl(receiptUrl)
      : await fetchCbeTransactionIdByToken(token)
    applyExtractedPaymentScan(result.transactionId, buildCbeScanReceiverDisplay(result))
    scannedCbeToken.value = ''
    cbeQrStatus.value = 'success'
    cbeQrStatusMessage.value = 'Scanned Successfully!'
    return result
  } catch (err) {
    cbeQrStatus.value = 'error'
    cbeQrStatusMessage.value = err?.message || 'CBE lookup failed'
    throw err
  } finally {
    cbeQrLookupInFlight = false
    isScanningTransaction.value = false
  }
}

async function getJsQr() {
  if (!jsQrModule) {
    jsQrModule = (await import('jsqr')).default
  }
  return jsQrModule
}

async function decodeQrFromCanvas(canvas) {
  const jsQR = await getJsQr()
  const variants = getQrCanvasVariants(canvas)
  for (const target of variants) {
    const ctx = target.getContext('2d')
    if (!ctx) continue
    const imageData = ctx.getImageData(0, 0, target.width, target.height)
    const code = jsQR(imageData.data, imageData.width, imageData.height, {
      inversionAttempts: 'attemptBoth',
    })
    if (code?.data) return code.data
  }
  return ''
}

function getQrCanvasVariants(canvas) {
  const variants = [canvas]
  const width = canvas.width
  const height = canvas.height
  const maxSize = 900
  const longest = Math.max(width, height)
  if (longest > maxSize) {
    const scale = maxSize / longest
    const scaled = document.createElement('canvas')
    scaled.width = Math.round(width * scale)
    scaled.height = Math.round(height * scale)
    const ctx = scaled.getContext('2d')
    if (ctx) {
      ctx.drawImage(canvas, 0, 0, scaled.width, scaled.height)
      variants.push(scaled)
    }
  }
  const cropSize = Math.min(width, height) * 0.75
  const cropX = (width - cropSize) / 2
  const cropY = (height - cropSize) / 2
  const cropped = document.createElement('canvas')
  cropped.width = Math.round(cropSize)
  cropped.height = Math.round(cropSize)
  const cropCtx = cropped.getContext('2d')
  if (cropCtx) {
    cropCtx.drawImage(canvas, cropX, cropY, cropSize, cropSize, 0, 0, cropped.width, cropped.height)
    variants.push(cropped)
  }
  const focusSize = Math.min(width, height) * 0.58
  const focus = document.createElement('canvas')
  focus.width = Math.round(focusSize)
  focus.height = Math.round(focusSize)
  const focusCtx = focus.getContext('2d')
  if (focusCtx) {
    focusCtx.imageSmoothingEnabled = false
    focusCtx.drawImage(canvas, (width - focusSize) / 2, (height - focusSize) / 2, focusSize, focusSize, 0, 0, focus.width, focus.height)
    const imageData = focusCtx.getImageData(0, 0, focus.width, focus.height)
    for (let index = 0; index < imageData.data.length; index += 4) {
      const gray = imageData.data[index] * 0.299 + imageData.data[index + 1] * 0.587 + imageData.data[index + 2] * 0.114
      const value = gray > 145 ? 255 : 0
      imageData.data[index] = value
      imageData.data[index + 1] = value
      imageData.data[index + 2] = value
    }
    focusCtx.putImageData(imageData, 0, 0)
    variants.push(focus)
  }
  return variants
}

async function getTxnBarcodeDetector() {
  if (txnBarcodeDetector) return txnBarcodeDetector
  if (typeof window === 'undefined' || !('BarcodeDetector' in window)) return null
  try {
    txnBarcodeDetector = new window.BarcodeDetector({ formats: ['qr_code'] })
    return txnBarcodeDetector
  } catch (err) {
    console.warn('BarcodeDetector unavailable:', err)
    return null
  }
}

async function decodeQrFromVideoFrame(video) {
  const canvas = captureVideoFrameCanvas(video)
  if (!canvas) return ''
  const detector = await getTxnBarcodeDetector()
  if (detector) {
    try {
      const bitmap = await createImageBitmap(canvas)
      const barcodes = await detector.detect(bitmap)
      bitmap.close?.()
      const data = barcodes?.[0]?.rawValue
      if (data) return data
    } catch (err) {
      console.warn('BarcodeDetector failed, falling back to jsQR:', err)
    }
  }
  return decodeQrFromCanvas(canvas)
}

async function waitForTxnVideoReady(video, timeoutMs = 6000) {
  if (video.videoWidth && video.videoHeight) return
  await new Promise((resolve, reject) => {
    const timeout = setTimeout(() => reject(new Error('Camera preview timed out.')), timeoutMs)
    const onReady = () => {
      if (!video.videoWidth || !video.videoHeight) return
      clearTimeout(timeout)
      video.removeEventListener('loadedmetadata', onReady)
      video.removeEventListener('playing', onReady)
      resolve()
    }
    video.addEventListener('loadedmetadata', onReady)
    video.addEventListener('playing', onReady)
    onReady()
  })
}

async function loadImageElementFromSource(source) {
  if (source instanceof HTMLVideoElement) {
    const canvas = captureVideoFrameCanvas(source)
    if (!canvas) throw new Error('Could not capture video frame')
    return await new Promise((resolve, reject) => {
      const image = new Image()
      image.onload = () => resolve(image)
      image.onerror = () => reject(new Error('Failed to load image'))
      image.src = canvas.toDataURL('image/jpeg', 0.92)
    })
  }
  if (source instanceof HTMLCanvasElement) {
    return await new Promise((resolve, reject) => {
      const image = new Image()
      image.onload = () => resolve(image)
      image.onerror = () => reject(new Error('Failed to load image'))
      image.src = source.toDataURL('image/jpeg', 0.92)
    })
  }
  const objectUrl = URL.createObjectURL(source)
  try {
    return await new Promise((resolve, reject) => {
      const image = new Image()
      image.onload = () => resolve(image)
      image.onerror = () => reject(new Error('Failed to load image'))
      image.src = objectUrl
    })
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}

async function decodeQrFromImageSource(source) {
  const image = await loadImageElementFromSource(source)
  const maxSize = 1200
  let width = image.width
  let height = image.height
  if (width > maxSize || height > maxSize) {
    const scale = maxSize / Math.max(width, height)
    width = Math.round(width * scale)
    height = Math.round(height * scale)
  }
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  if (!ctx) return ''
  ctx.drawImage(image, 0, 0, width, height)
  return decodeQrFromCanvas(canvas)
}

function extractCbeTransactionIdFromQrContent(content) {
  if (!content) return ''
  const text = String(content).trim()

  const urlIdMatch = text.match(/[?&]id=([^&\s#]+)/i)
  if (urlIdMatch?.[1]) {
    const idValue = decodeURIComponent(urlIdMatch[1]).toUpperCase()
    const withSuffix = idValue.match(/^(FT[A-Z0-9]{8,12})(\d{8})$/)
    if (withSuffix?.[1] && isValidCbeTxnValue(withSuffix[1])) {
      return withSuffix[1]
    }
    if (isValidCbeTxnValue(idValue)) {
      return idValue
    }
    const candidate = pickCbeTxnCandidate(idValue)
    if (candidate) return candidate
  }

  const receiptMatch = text.match(/receipt\s*no\.?\s*[:-]?\s*(FT[A-Z0-9]{8,16})/i)
  if (receiptMatch?.[1] && isValidCbeTxnValue(receiptMatch[1])) {
    return cleanTxnId(receiptMatch[1]).toUpperCase()
  }

  return pickCbeTxnCandidate(text)
}

function extractTransactionIdFromQrContent(content, paymentMethod = null) {
  if (!content) return ''
  const name = normalizePaymentMethodName(paymentMethod)
  if (isCbeMethod(name)) {
    return extractCbeTransactionIdFromQrContent(content)
  }
  return ''
}

async function preprocessImageForOcr(source) {
  let objectUrl = null
  try {
    const img = await new Promise((resolve, reject) => {
      const image = new Image()
      image.onload = () => resolve(image)
      image.onerror = () => reject(new Error('Failed to load image'))
      if (source instanceof HTMLCanvasElement) {
        image.src = source.toDataURL('image/jpeg', 0.92)
        return
      }
      if (source instanceof Blob || source instanceof File) {
        objectUrl = URL.createObjectURL(source)
        image.src = objectUrl
        return
      }
      image.src = source
    })

    const maxDim = 1600
    let width = img.naturalWidth || img.width
    let height = img.naturalHeight || img.height
    if (!width || !height) throw new Error('Invalid image dimensions')
    if (width > maxDim || height > maxDim) {
      const ratio = Math.min(maxDim / width, maxDim / height)
      width = Math.round(width * ratio)
      height = Math.round(height * ratio)
    }

    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('Canvas not supported')
    ctx.drawImage(img, 0, 0, width, height)

    const imageData = ctx.getImageData(0, 0, width, height)
    const pixels = imageData.data
    for (let i = 0; i < pixels.length; i += 4) {
      const gray = 0.299 * pixels[i] + 0.587 * pixels[i + 1] + 0.114 * pixels[i + 2]
      const boosted = gray < 128 ? gray * 0.75 : Math.min(255, gray * 1.25)
      pixels[i] = pixels[i + 1] = pixels[i + 2] = boosted
    }
    ctx.putImageData(imageData, 0, 0)

    return canvas
  } finally {
    if (objectUrl) URL.revokeObjectURL(objectUrl)
  }
}

async function getTesseractWorker() {
  if (!tesseractWorker) {
    const { createWorker } = await import('tesseract.js')
    tesseractWorker = await createWorker('eng', 1, { logger: () => {} })
    await tesseractWorker.setParameters({
      tessedit_pageseg_mode: '3',
      preserve_interword_spaces: '1',
    })
  }
  return tesseractWorker
}

async function terminateTesseractWorker() {
  if (tesseractWorker) {
    await tesseractWorker.terminate()
    tesseractWorker = null
  }
}

function ensureMediaDevices() {
  if (typeof navigator === 'undefined') return false
  if (!navigator.mediaDevices?.getUserMedia) {
    const legacy =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia
    return typeof legacy === 'function'
  }
  return true
}

function canUseLiveCamera() {
  return typeof window !== 'undefined' && window.isSecureContext && ensureMediaDevices()
}

function isMobileDevice() {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '')
}

function getCameraErrorMessage(err) {
  if (!err) return 'Could not access camera.'
  if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
    return 'Camera permission denied. Allow camera access in your browser settings.'
  }
  if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
    return 'No camera found on this device.'
  }
  if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
    return 'Camera is busy or unavailable. Close other apps using the camera and try again.'
  }
  return err.message || 'Could not access camera.'
}

async function requestTxnCameraStream() {
  if (!ensureMediaDevices()) {
    throw new Error('Camera access is unavailable. Use HTTPS and allow camera permission.')
  }
  const getUserMedia = navigator.mediaDevices?.getUserMedia
  if (typeof getUserMedia !== 'function') {
    const legacy = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia
    if (typeof legacy !== 'function') {
      throw new Error('Camera access is unavailable. Use HTTPS and allow camera permission.')
    }
    return new Promise((resolve, reject) => legacy.call(navigator, { video: { facingMode: { ideal: 'environment' } }, audio: false }, resolve, reject))
  }
  const constraintsList = [
    { video: { facingMode: { ideal: 'environment' } }, audio: false },
    { video: { facingMode: 'environment' }, audio: false },
    { video: { facingMode: 'user' }, audio: false },
    { video: true, audio: false },
  ]
  let lastError = null
  for (const constraints of constraintsList) {
    try {
      return await getUserMedia.call(navigator.mediaDevices, constraints)
    } catch (err) {
      lastError = err
      if (err?.name === 'NotAllowedError' || err?.name === 'PermissionDeniedError') break
    }
  }
  throw lastError || new Error('Could not access camera.')
}

async function recognizeTransactionFromLiveFrame(worker, canvas, paymentMethod) {
  let imageSource = canvas
  try {
    imageSource = await preprocessImageForOcr(canvas)
  } catch (err) {
    console.warn('Live OCR preprocess skipped:', err)
  }

  const psmModes = ['6', '11', '3']
  for (const psm of psmModes) {
    await worker.setParameters({
      tessedit_pageseg_mode: psm,
      preserve_interword_spaces: '1',
    })
    const scanResult = await worker.recognize(imageSource)
    const ocrText = scanResult.data.text
    const mismatchMessage = detectPaymentScreenshotMismatch(ocrText, paymentMethod)
    if (mismatchMessage) continue
    const extracted = extractTransactionIdFromOcrText(ocrText, paymentMethod)
    if (extracted && isTxnIdValidForPaymentMethod(extracted, paymentMethod)) {
      await worker.setParameters({ tessedit_pageseg_mode: '3', preserve_interword_spaces: '1' })
      return { extracted, receiverDisplay: extractScannedReceiverDisplay(ocrText, paymentMethod), error: '' }
    }
  }

  await worker.setParameters({ tessedit_pageseg_mode: '3', preserve_interword_spaces: '1' })
  return { extracted: '', receiverDisplay: '', error: '' }
}

function captureVideoFrameCanvas(video) {
  const width = video.videoWidth
  const height = video.videoHeight
  if (!width || !height) return null

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  if (!ctx) return null
  ctx.drawImage(video, 0, 0, width, height)
  return canvas
}

function stopLiveTxnScanLoop() {
  if (txnLiveScanTimer) {
    clearInterval(txnLiveScanTimer)
    txnLiveScanTimer = null
  }
  if (txnQrScanRafId) {
    cancelAnimationFrame(txnQrScanRafId)
    txnQrScanRafId = null
  }
  if (cbeZxingControls) {
    cbeZxingControls.stop()
    cbeZxingControls = null
  }
  txnLiveScanBusy = false
  txnLiveScanProcessing.value = false
}

function stopTxnLiveCameraHardware() {
  stopLiveTxnScanLoop()
  stopTxnCamera()
  showTxnLiveCameraScan.value = false
}

function stopLiveTxnCameraScan() {
  stopTxnLiveCameraHardware()
  txnLiveScanPurpose.value = 'ocr'
  txnPendingQrDecode = false
}

function closeLiveTxnCameraScan() {
  stopLiveTxnCameraScan()
}

function startLiveTxnScanLoop() {
  stopLiveTxnScanLoop()
  if (txnLiveScanPurpose.value === 'qr') {
    startCbeZxingScan().catch((error) => {
      console.warn('CBE QR scanner failed:', error)
      showToast(getCameraErrorMessage(error), 'error')
    })
    return
  }
  const tick = () => {
    runLiveTxnScanTick().catch(() => {})
  }
  tick()
  txnLiveScanTimer = setInterval(tick, 1400)
}

async function startCbeZxingScan() {
  const video = txnLiveScanVideo.value
  if (!video) throw new Error('Camera preview is not ready. Please try again.')
  if (!cbeZxingReader) cbeZxingReader = new BrowserMultiFormatReader()
  cbeZxingControls = await cbeZxingReader.decodeFromStream(
    txnScanCameraStream,
    video,
    async (result, error) => {
      const qrContent = result?.getText?.()
      if (qrContent && !cbeQrLookupInFlight && showTxnLiveCameraScan.value) {
        try {
          const resolved = await resolveCbeTransactionFromQrContent(qrContent)
          if (resolved?.transactionId) {
            showToast('Transaction ID extracted from QR code', 'success')
            stopLiveTxnCameraScan()
            closeTxnScanModal()
          }
        } catch (lookupError) {
          if (extractCbeReceiptToken(qrContent)) {
            showToast(lookupError?.message || 'CBE lookup failed', 'error')
            stopLiveTxnCameraScan()
            closeTxnScanModal()
          }
        }
      } else if (error && error.name !== 'NotFoundException') {
        console.warn('CBE QR frame decode failed:', error)
      }
    },
  )
}

async function runLiveTxnScanTick() {
  if (txnLiveScanBusy || !showTxnLiveCameraScan.value || cbeQrLookupInFlight || isScanningTransaction.value) return

  const video = txnLiveScanVideo.value
  if (!video || !video.videoWidth) return

  txnLiveScanBusy = true
  txnLiveScanProcessing.value = true
  try {
    if (txnLiveScanPurpose.value === 'qr') {
      const qrContent = await decodeQrFromVideoFrame(video)
      if (qrContent) {
        try {
          const result = await resolveCbeTransactionFromQrContent(qrContent)
          if (result?.transactionId) {
            showToast('Transaction ID extracted from QR code', 'success')
            stopLiveTxnCameraScan()
            closeTxnScanModal()
          }
        } catch (qrErr) {
          if (extractCbeReceiptToken(qrContent)) {
            showToast(qrErr.message || 'CBE lookup failed', 'error')
            stopLiveTxnCameraScan()
            closeTxnScanModal()
          }
        }
      }
      return
    }

    const canvas = captureVideoFrameCanvas(video)
    if (!canvas) return

    const worker = await getTesseractWorker()
    const { extracted, receiverDisplay } = await recognizeTransactionFromLiveFrame(worker, canvas, selectedPaymentMethod.value)
    if (extracted) {
      applyExtractedPaymentScan(extracted, receiverDisplay)
      showToast('Transaction ID extracted successfully', 'success')
      stopLiveTxnCameraScan()
      closeTxnScanModal()
    }
  } catch (err) {
    console.warn('Live transaction scan tick failed:', err)
  } finally {
    txnLiveScanBusy = false
    if (showTxnLiveCameraScan.value) {
      txnLiveScanProcessing.value = false
    }
  }
}

async function startLiveTxnCameraScan(purpose = 'ocr') {
  if (isScanningTransaction.value || showTxnLiveCameraScan.value) return

  if (!canUseLiveCamera()) {
    txnLiveScanPurpose.value = purpose
    if (isMobileDevice()) {
      txnPendingQrDecode = purpose === 'qr'
      openNativeTxnCamera()
      return
    }
    const insecure = typeof window !== 'undefined' && !window.isSecureContext
    showToast(
      insecure
        ? 'Live camera needs HTTPS. Use Gallery or open this page over a secure connection.'
        : 'Camera is not supported on this browser.',
      'error'
    )
    return
  }

  try {
    stopTxnLiveCameraHardware()
    txnLiveScanPurpose.value = purpose
    if (purpose === 'qr') await getJsQr()
    else getTesseractWorker().catch(() => {})

    showTxnLiveCameraScan.value = true
    await nextTick()
    txnScanCameraStream = await requestTxnCameraStream()
    await nextTick()

    const video = txnLiveScanVideo.value
    if (!video) throw new Error('Camera preview is not ready. Please try again.')
    video.setAttribute('playsinline', 'true')
    video.setAttribute('webkit-playsinline', 'true')
    video.srcObject = txnScanCameraStream
    await video.play().catch(() => {})
    await waitForTxnVideoReady(video)
    startLiveTxnScanLoop()
  } catch (err) {
    console.error('Live camera scan failed:', err)
    const failedPurpose = purpose
    stopLiveTxnCameraScan()
    if (failedPurpose !== 'qr' && isMobileDevice()) {
      txnLiveScanPurpose.value = failedPurpose
      txnPendingQrDecode = failedPurpose === 'qr'
      openNativeTxnCamera()
      return
    }
    showToast(getCameraErrorMessage(err), 'error')
  }
}

function openNativeTxnCamera() {
  txnScanCameraInput.value?.click()
}

function stopTxnCamera() {
  if (txnScanCameraStream) {
    txnScanCameraStream.getTracks().forEach((track) => track.stop())
    txnScanCameraStream = null
  }
  if (txnScanVideo.value) txnScanVideo.value.srcObject = null
  if (txnLiveScanVideo.value) txnLiveScanVideo.value.srcObject = null
}

function closeTxnScanSourcePicker() {
  showTxnScanSourcePicker.value = false
}

function pickTxnCameraFromSourcePicker() {
  closeTxnScanSourcePicker()
  startLiveTxnCameraScan('ocr')
}

function pickTxnGalleryFromSourcePicker() {
  closeTxnScanSourcePicker()
  txnPendingQrDecode = false
  pickTxnScreenshot()
}

function pickTxnQrFromSourcePicker() {
  closeTxnScanSourcePicker()
  if (cbeQrStatus.value !== 'success') {
    cbeQrStatus.value = ''
    cbeQrStatusMessage.value = ''
  }
  startLiveTxnCameraScan('qr')
}

function closeTxnScanModal() {
  stopLiveTxnCameraScan()
  stopTxnCamera()
  showTxnScanModal.value = false
  txnScanMode.value = 'chooser'
}

function pickTxnScreenshot() {
  txnScanFileInput.value?.click()
}

function openTxnScanPicker() {
  if (isScanningTransaction.value) return
  if (isCbePaymentSelected.value) {
    openHostedCbeScanner()
    return
  }
  getTesseractWorker().catch(() => {})
  if (isMobileDevice() || isCbePaymentSelected.value || isTelebirrPaymentSelected.value) {
    showTxnScanSourcePicker.value = true
    return
  }
  pickTxnScreenshot()
}

async function recognizeTransactionFromImage(worker, source, paymentMethod) {
  const imageSources = []
  try {
    const processedCanvas = await preprocessImageForOcr(source)
    imageSources.push(processedCanvas)
  } catch (err) {
    console.warn('OCR preprocess skipped:', err)
  }

  if (source instanceof File || source instanceof Blob || source instanceof HTMLCanvasElement) {
    if (!imageSources.includes(source)) imageSources.push(source)
  }

  const psmModes = ['3', '6', '11']
  let lastMismatchMessage = ''
  let receiverDisplay = ''
  for (const imageSource of imageSources) {
    for (const psm of psmModes) {
      await worker.setParameters({
        tessedit_pageseg_mode: psm,
        preserve_interword_spaces: '1',
      })
      const scanResult = await worker.recognize(imageSource)
      const ocrText = scanResult.data.text
      const mismatchMessage = detectPaymentScreenshotMismatch(ocrText, paymentMethod)
      if (mismatchMessage) {
        lastMismatchMessage = mismatchMessage
        continue
      }
      if (!receiverDisplay) {
        receiverDisplay = extractScannedReceiverDisplay(ocrText, paymentMethod)
      }
      const extracted = extractTransactionIdFromOcrText(ocrText, paymentMethod)
      if (extracted && isTxnIdValidForPaymentMethod(extracted, paymentMethod)) {
        await worker.setParameters({ tessedit_pageseg_mode: '3', preserve_interword_spaces: '1' })
        return {
          extracted,
          receiverDisplay: extractScannedReceiverDisplay(ocrText, paymentMethod) || receiverDisplay,
          error: '',
        }
      }
    }
  }

  await worker.setParameters({ tessedit_pageseg_mode: '3', preserve_interword_spaces: '1' })
  return { extracted: '', receiverDisplay, error: lastMismatchMessage }
}

async function processTxnQrScanImage(source) {
  if (cbeQrLookupInFlight || isScanningTransaction.value) return
  isScanningTransaction.value = true
  try {
    const qrContent = await decodeQrFromImageSource(source)
    if (!qrContent) throw new Error('No QR code found in the image. Try again with a clearer image.')

    const result = await resolveCbeTransactionFromQrContent(qrContent)
    if (!result?.transactionId) {
      throw new Error(getTxnQrScanErrorMessage(selectedPaymentMethod.value))
    }
    showToast('Transaction ID extracted from QR code', 'success')
    closeTxnScanModal()
    closeLiveTxnCameraScan()
  } catch (err) {
    console.error('QR scan failed:', err)
    showToast(err.message || 'QR scan failed. Try again.', 'error')
  } finally {
    isScanningTransaction.value = false
    txnLiveScanPurpose.value = 'ocr'
    txnPendingQrDecode = false
  }
}

async function processTxnScanImage(source) {
  isScanningTransaction.value = true
  scannedReceiverDisplay.value = ''
  try {
    const name = normalizePaymentMethodName(selectedPaymentMethod.value)
    let extractedFromQr = ''
    if (isCbeMethod(name)) {
      try {
        const qrContent = await decodeQrFromImageSource(source)
        if (qrContent) {
          const qrExtracted = extractTransactionIdFromQrContent(qrContent, selectedPaymentMethod.value)
          if (qrExtracted && isTxnIdValidForPaymentMethod(qrExtracted, selectedPaymentMethod.value)) {
            extractedFromQr = qrExtracted
          }
        }
      } catch (qrErr) {
        console.warn('QR decode skipped, falling back to OCR:', qrErr)
      }
    }

    const worker = await getTesseractWorker()
    const { extracted, error, receiverDisplay } = await recognizeTransactionFromImage(worker, source, selectedPaymentMethod.value)
    const finalId = extractedFromQr || extracted

    if (!finalId) {
      if (error) throw new Error(error)
      throw new Error(getTxnScanErrorMessage(selectedPaymentMethod.value))
    }

    applyExtractedPaymentScan(finalId, receiverDisplay)
    showToast(
      extractedFromQr ? 'Transaction ID extracted from QR code' : 'Transaction ID extracted successfully',
      'success'
    )
    closeTxnScanModal()
  } catch (err) {
    console.error('Transaction scan failed:', err)
    showToast(err.message || 'Scan failed. Try again with a clearer image.', 'error')
  } finally {
    isScanningTransaction.value = false
  }
}

async function handleTxnScanFile(event) {
  const file = event.target.files?.[0]
  event.target.value = ''
  if (!file) return
  if (txnPendingQrDecode || txnLiveScanPurpose.value === 'qr') {
    await processTxnQrScanImage(file)
    return
  }
  await processTxnScanImage(file)
}

async function startTxnCamera() {
  await startLiveTxnCameraScan()
}

async function captureAndScanTransaction() {
  const video = txnScanVideo.value
  if (!video || !video.videoWidth) {
    showToast('Camera is not ready yet. Please wait a moment.', 'error')
    return
  }
  const canvas = document.createElement('canvas')
  canvas.width = video.videoWidth
  canvas.height = video.videoHeight
  const ctx = canvas.getContext('2d')
  if (!ctx) {
    showToast('Could not capture camera frame.', 'error')
    return
  }
  ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
  await processTxnScanImage(canvas)
}

const showTransferModal = ref(false)
const isSending = ref(false)
const transferRequests = ref([])
const transferUIState = ref({}) // { [requestId]: { action: 'Merge' | 'New Table', targetTable: string } }
const waiters = ref([])
const selectedWaiterId = ref('')
const allOrdersWaiterFilter = ref('')
const transferBadgeCount = computed(() => transferRequests.value.length)

const pendingTables = computed(() => {
  if (!Array.isArray(orderGroups.value)) return []
  
  const uid = currentUser.value?.id || currentUser.value?.sub
  const today = new Date().toISOString().split('T')[0] // YYYY-MM-DD
  
  // Strictly filter for the current user's own tables. 
  // When accepting a transfer, the user should only merge into their own active tables.
  const filteredGroups = orderGroups.value.filter(g => {
    if (!g.table) return false
    const orderDate = g.createdAt ? String(g.createdAt).split('T')[0] : ''
    if (orderDate !== today) return false
    return String(g.waiterId) === String(uid)
  })

  const tables = filteredGroups.map(g => g.table)
  return [...new Set(tables)].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
})

function setTransferTableDigit(reqId, digit) {
  if (!transferUIState.value[reqId]) {
    transferUIState.value[reqId] = { action: 'New Table', targetTable: '' }
  }
  transferUIState.value[reqId].targetTable += digit.toString()
}

function clearTransferTable(reqId) {
  if (transferUIState.value[reqId]) {
    transferUIState.value[reqId].targetTable = ''
  }
}

function toggleTransferAction(reqId, state) {
  if (transferUIState.value[reqId]) {
    transferUIState.value[reqId].showAction = state
  }
}

async function loadWaiters() {
  try {
    const endpoint = branchId.value ? `/users/branch/${branchId.value}` : `/users/company/${companyId.value}`
    const response = await apiFetch(endpoint)
    if (response.ok) {
      waiters.value = await response.json()
      waiters.value = waiters.value.filter(w => w.status === 1);
      waiters.value = waiters.value.filter(w => w.role.toLowerCase().includes('waiter'));
    }
  } catch (err) {
    console.error('Failed to load waiters', err)
  }
}

function currentOrderGroupHasPendingTransfer() {
  if (!currentEditingOrderId.value) return false
  const o = orders.value.find((x) => x.id === currentEditingOrderId.value)
  if (!o) return false
  if (o.hasPendingTransfer) return true
  return Array.isArray(o.items) && o.items.some(
    (i) => Array.isArray(i.transfers) && i.transfers.some((t) => Number(t.isAccepted) === 0)
  )
}

function blockIfOrderGroupHasPendingTransfer() {
  if (!currentOrderGroupHasPendingTransfer()) return false
  showToast(
    'This order group has pending transfer. Please wait until Accepted or rejected.',
    'error'
  )
  return true
}

function getOrderUpdatedAtForGroup(orderGroupId = currentEditingOrderId.value) {
  if (
    String(orderGroupId) === String(currentEditingOrderId.value)
    && Array.isArray(editingOrderUpdatedAt.value)
  ) {
    return editingOrderUpdatedAt.value.map(item => ({ ...item }))
  }

  const group = orders.value.find(order => String(order.id) === String(orderGroupId))
  if (!group || !Array.isArray(group.items)) return []
  return group.items
    .map(item => ({ id: item.itemId ?? item.id, updatedAt: item.updatedAt }))
    .filter(item => item.id != null && typeof item.updatedAt === 'string')
}

function updateLoadedOrderUpdatedAt(orderId, updatedAt) {
  if (typeof updatedAt !== 'string') return
  editingOrderUpdatedAt.value = editingOrderUpdatedAt.value.map(item =>
    String(item.id) === String(orderId) ? { ...item, updatedAt } : item
  )
  for (const group of orders.value) {
    const item = group.items?.find(row => String(row.itemId ?? row.id) === String(orderId))
    if (item) item.updatedAt = updatedAt
  }
}

async function transferSelectedItems() {
  if (blockIfOrderGroupHasPendingTransfer()) return

  const selectedOrderIds = billItems.value
    .filter(item => item.selected && item.orderId)
    .flatMap(item => {
      const ids = []
      if (item.itemId) ids.push(item.itemId)
      if (item.transferredItemId) ids.push(item.transferredItemId)
      return ids
    });

  if (selectedOrderIds.length === 0) {
    showToast('No saved items selected for transfer', 'error');
    return;
  }
  if (!selectedWaiterId.value) {
    showToast('Please select a waiter', 'error');
    return;
  }

  try {
    const response = await apiFetch('/order-transfers/bulk', {
      method: 'POST',
      body: JSON.stringify({
        senderId: currentUser.value.id,
        receiverId: selectedWaiterId.value,
        orderIds: selectedOrderIds,
        orderUpdatedAt: getOrderUpdatedAtForGroup()
      })
    });

    if (response.ok) {
      showToast('Transfer request sent successfully', 'success');
      selectedWaiterId.value = '';
      
      // Do not remove items immediately; just uncheck them so they remain in the list until accepted
      billItems.value.forEach(item => { 
        if (item.selected) item.selected = false; 
      });

      // Refresh orders
      await fetchOrders(false);
      clearBillAreaOnly()
      // If bill is empty, clear it
      if (billItems.value.length === 0) {
        clearBill(true);
      }
    } else {
      const errorData = await response.json().catch(() => ({}))
      showToast(errorData.message || 'Failed to create transfer request', 'error');
    }
  } catch (err) {
    console.error('Transfer failed', err);
    showToast('Transfer failed', 'error');
  }
}



function toggleAllItems(req, checked) {
  req.items.forEach(item => { item.selected = checked })
}

async function fetchTransferRequests() {
  try {
    const response = await apiFetch(`/order-transfers?receiverId=${currentUser.value?.id}`)
    if (response.ok) {
      const data = await response.json()
      // Preserve local selections and initialize UI state
      data.forEach(req => {
        const existingReq = transferRequests.value.find(r => r.id === req.id)
        if (existingReq && existingReq.items) {
          req.items.forEach(newItem => {
            const existingItem = existingReq.items.find(i => i.transferId === newItem.transferId)
            if (existingItem && existingItem.selected) {
              newItem.selected = existingItem.selected
            }
          })
        }
        if (!transferUIState.value[req.id]) {
          transferUIState.value[req.id] = { action: '', targetTable: '', showAction: false }
        }
      })
      transferRequests.value = data
    }
  } catch (error) {
    console.error('Failed to fetch transfers:', error)
  }
}

async function acceptTransfer(transferIdString, tableNumber = null, orderGroupId = null, reqId = null) {
  try {
    const body = { isAccepted: 1, receiverId: currentUser.value?.id }
    if (tableNumber) body.tableNumber = tableNumber
    if (orderGroupId) body.orderGroupId = orderGroupId
    const request = transferRequests.value.find(item => String(item.id) === String(reqId))
    body.orderUpdatedAt = request?.orderUpdatedAt || []

    const response = await apiFetch(`/order-transfers/${transferIdString}/status`, {
      method: 'PATCH',
      body: JSON.stringify(body)
    })
    if (response.ok) {
      showToast('Transfer accepted', 'success')
      // Clear specify UI state to close the action drawer
      if (reqId) {
        delete transferUIState.value[reqId]
      }
      await fetchTransferRequests()
      if(transferRequests.value.length === 0){ showTransferModal.value = false}
      await fetchOrders()
    } else {
      const errorData = await response.json().catch(() => ({}))
      showToast(errorData.message || 'Failed to accept transfer', 'error')
    }
  } catch (error) {
    console.error('Accept transfer failed:', error)
    showToast('Failed to accept transfer', 'error')
  }
}

// Resolve destination params for a transfer request base on action
function resolveTransferDestination(reqId) {
  const state = transferUIState.value[reqId]
  if (!state) return null

  const action = state.action
  const targetTable = state.targetTable

  if (action === 'Merge') {
    if (!targetTable) {
      showToast('Please select an existing table', 'error')
      return null
    }
    // Find the orderGroupId of the selected table (STRICT: today + current user + same table)
    const uid = currentUser.value?.id || currentUser.value?.sub
    const today = new Date().toISOString().split('T')[0] // YYYY-MM-DD
    const matchingOrder = orderGroups.value.find(o => {
      const orderDate = o?.createdAt ? String(o.createdAt).split('T')[0] : ''
      return (
        String(o?.table) === String(targetTable) &&
        String(o?.waiterId) === String(uid) &&
        orderDate === today
      )
    })
    if (!matchingOrder) {
      showToast('Selected table not found in active orders', 'error')
      return null
    }
    return { tableNumber: targetTable, orderGroupId: matchingOrder.id }
  }

  if (action === 'New Table') {
    if (!targetTable) {
      showToast('Please enter a new table number', 'error')
      return null
    }
    // Validate new table does not already exist
    const exists = pendingTables.value.some(t => String(t) === String(targetTable))
    if (exists) {
      showToast(`Table ${targetTable} already exists. Choose Merge instead.`, 'error')
      return null
    }
    return { tableNumber: targetTable, orderGroupId: `group-table-${targetTable}-${Date.now()}` }
  }

  showToast('Please select an action (Merge or New Table)', 'error')
  return null
}

async function rejectTransfer(transferIdString, reqId = null) {
  try {
    const response = await apiFetch(`/order-transfers/${transferIdString}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ isAccepted: 2 })
    })
    if (response.ok) {
      showToast('Transfer rejected', 'info')
      if (reqId) {
        delete transferUIState.value[reqId]
      }
      await fetchTransferRequests()
    } else {
      showToast('Failed to reject transfer', 'error')
    }
  } catch (error) {
    console.error('Reject transfer failed:', error)
    showToast('Failed to reject transfer', 'error')
  }
}

watch(showTransferModal, (newVal) => {
  if (newVal) {
    fetchTransferRequests()
  } else {
    // Reset all UI states when closing
    transferUIState.value = {}
    transferRequests.value.forEach(req => {
      if (req.items) {
        req.items.forEach(item => { if (item.selected) item.selected = false })
      }
    })
  }
})

// currentUser moved to top
function persistOrders() {
  localStorage.setItem('posOrders', JSON.stringify(orders.value))
}

function syncExcludes() {
  billItems.value.forEach(item => {
    if (item.ingredients?.length) {
      item.excludeIngredients = item.ingredients.filter(ing => !ing.checked).map(ing => ing.name).join(', ')
    }
  })
}

function normalizeIngredientType(v) {
  const s = String(v || '').toLowerCase()
  if (s.includes('product')) return 'product'
  if (s.includes('item')) return 'item'
  return s
}

function buildOrderIngredientAndAmount(item) {
  const snapshot = item?.menu?.latestSavedMenuRecipe || null
  const raw = snapshot?.ingredient_and_amount ?? snapshot?.ingredientAndAmount ?? null
  if (!Array.isArray(raw)) return null

  const uncheckedKeys = new Set(
    Array.isArray(item?.ingredients)
      ? item.ingredients
          .filter(ing => ing && ing.checked === false)
          .map(ing => {
            const id = Number(ing.sourceId ?? ing.Id ?? ing.id)
            const t = normalizeIngredientType(ing.sourceType ?? ing.type)
            return Number.isFinite(id) ? `${t}:${id}` : null
          })
          .filter(Boolean)
      : []
  )

  const filtered = raw.filter(entry => {
    const id = Number(entry?.Id ?? entry?.id)
    const t = normalizeIngredientType(entry?.type)
    if (!Number.isFinite(id) || !t) return true
    return !uncheckedKeys.has(`${t}:${id}`)
  })

  // Return exactly as `{ Id, type, amount }`
  return filtered.map(entry => ({
    Id: Number(entry?.Id ?? entry?.id),
    type: entry?.type,
    amount: Number(entry?.amount),
  }))
}

onMounted(() => {
  window.addEventListener('message', handleHostedCbeScannerMessage)
  // const saved = localStorage.getItem('posOrders')
  // if (saved) orders.value = JSON.parse(saved)

  // Auto-fill waiter from logged-in user
  if (currentUser.value) {
    selectedWaiter.value = currentUser.value.full_name || currentUser.value.username || ''
  }

  // Pre-fetch orders to enable table number validation
  fetchOrders(false)
  loadWaiters()
  fetchTransferRequests()
  connectOrderSyncRealtime()

  // Periodic refresh for badges
  setInterval(fetchTransferRequests, 30000)
})

onUnmounted(() => {
  window.removeEventListener('message', handleHostedCbeScannerMessage)
  hostedCbeScannerWindow?.close?.()
  hostedCbeScannerWindow = null
  disconnectOrderSyncRealtime()
  stopLiveTxnCameraScan()
  stopTxnCamera()
  terminateTesseractWorker()
})

watch(showPaymentModal, (open) => {
  if (!open) {
    closeTxnScanModal()
    closeLiveTxnCameraScan()
  }
})

let orderSyncSocket = null
let orderSyncReconnectTimer = null
let orderSyncRefreshTimer = null

function scheduleOrderSyncRefresh() {
  if (orderSyncRefreshTimer) clearTimeout(orderSyncRefreshTimer)
  orderSyncRefreshTimer = setTimeout(() => {
    orderSyncRefreshTimer = null
    // Keep current bill/edit view; only refresh live order lists quietly.
    fetchOrders(false)
    fetchTransferRequests()
  }, 300)
}

function disconnectOrderSyncRealtime() {
  if (orderSyncReconnectTimer) {
    clearTimeout(orderSyncReconnectTimer)
    orderSyncReconnectTimer = null
  }
  if (orderSyncRefreshTimer) {
    clearTimeout(orderSyncRefreshTimer)
    orderSyncRefreshTimer = null
  }
  if (orderSyncSocket) {
    try {
      orderSyncSocket.close()
    } catch (_) {
      // ignore close failures
    }
    orderSyncSocket = null
  }
}

function connectOrderSyncRealtime() {
  disconnectOrderSyncRealtime()

  const user = currentUser.value
  if (!user || typeof WebSocket === 'undefined') return

  const companyIdValue = user.companyId || user.company_id || user.company?.id
  if (!companyIdValue) return

  const branchIdValue = user.branchId || user.branch_id || user.branch?.id || null
  const socket = new WebSocket(WS_BASE_URL)
  orderSyncSocket = socket

  socket.addEventListener('open', () => {
    socket.send(JSON.stringify({
      type: 'frontend.subscribe',
      company_id: companyIdValue,
      branch_id: branchIdValue,
    }))
  })

  socket.addEventListener('message', (event) => {
    try {
      const message = JSON.parse(event.data)
      if (message.event?.startsWith('order_group.')) {
        scheduleOrderSyncRefresh()
      }
    } catch (_) {
      // ignore malformed realtime payloads
    }
  })

  socket.addEventListener('close', () => {
    orderSyncSocket = null
    orderSyncReconnectTimer = setTimeout(() => {
      connectOrderSyncRealtime()
    }, 3000)
  })
}

async function fetchOrders(switchView = true) {
  if (switchView) {
    printFailures.value = []
  }
  try {
    const waiterIdParam = canViewAllOrders.value ? '' : (currentUser.value?.id || '')
    
    // Fetch only pending (isPaid=0) orders for the current user/waiter
    const query = `/orders?companyId=${companyId.value}&branchId=${branchId.value || ''}&waiterId=${waiterIdParam}&isPaid=0&isForStaff=Normal`
    const response = await apiFetch(query)
    
    if (!response.ok) {
        console.error('Fetch orders failed:', response.statusText)
        showToast('Failed to fetch live orders.', 'error')
        orders.value = []
        if (switchView && !isWaiterRole.value) viewMode.value = 'orders'
        return
    }

    const data = await response.json()
    
    // Safety check: ensure data is an array
    if (!Array.isArray(data)) {
      console.error('Expected array from fetchOrders, but got:', data)
      showToast('Live orders data is invalid.', 'error')
      orders.value = []
      if (switchView && !isWaiterRole.value) viewMode.value = 'orders'
      return
    }

    // Group backend items by orderGroupId (bill)
    const groupsMap = {}
    data.forEach(item => {
      const gid = item.orderGroupId || item.createdAt || 'default'
      if (!groupsMap[gid]) {
        groupsMap[gid] = {
          id: gid,
          createdAt: item.createdAt,
          waiterName: item.waiterFullName || 'Unknown',
          waiterId: item.waiterId,
          table: item.tableNumber,
          isPaid: item.isPaid,
          isDelivery: !!item.deliveryId, // or item.isDelivery if it exists, but usually its by presence of deliveryId
          deliveryId: item.deliveryId,
          deliveryCompanyName: item.deliveryCompanyName || null,
          deliveryCode: item.deliveryCode,
          dailyOrderNo: item.dailyOrderNo,
          transferStatus: null, // 0: pending, 1: accepted
          hasPendingTransfer: false,
          isPrinted: 1, // Will be set to 0 if any item is 0
          items: []
        }
      }

      // DEBUG: console.log('Checking item print status:', item.id, item.isPrinted)
      if (item.isPrinted === 0) {
        groupsMap[gid].isPrinted = 0
        // console.log('Marking group as failed print:', gid)
      }

      // Track transfer status for the group
      if (item.transfers) {
        if (item.transfers.some(t => t.isAccepted === 0)) {
          groupsMap[gid].hasPendingTransfer = true
        }
        if (item.transfers.some(t => t.isAccepted === 0 && t.receiverId === currentUser.value?.id)) {
          groupsMap[gid].transferStatus = 0;
        } else if (item.transfers.some(t => t.isAccepted === 1 && t.receiverId === currentUser.value?.id)) {
          groupsMap[gid].transferStatus = 1;
        }
      }

      groupsMap[gid].items.push({
        itemId: item.id, // Database record ID
        updatedAt: item.updatedAt,
        menuId: item.menuId,
        menu: item.menu, // Full menu object with departmentId
        name: item.menu?.name || 'Item',
        qty: item.quantity,
        // Keep both legacy and DB-shaped fields available.
        // IMPORTANT: totals should use qty * unit_price (not "price").
        unitPrice: item.unitPrice ?? item.unit_price ?? item.unitPrice,
        unit_price: item.unit_price ?? item.unitPrice ?? item.unitPrice,
        total_price: item.total_price ?? item.totalPrice ?? item.total_price,
        // Preserve the originally saved values; do NOT overwrite on confirm.
        price: item.price ?? item.unitPrice ?? item.unit_price ?? 0,
        addition: item.addition ?? 0,
        vat: item.vat ?? 0,
        excludeIngredients: item.excludeIngredients || '',
        note: item.note || '',
        isPrinted: item.isPrinted,
        notPrintedCount: item.not_printed_count || 0,
        transfers: item.transfers || []
      })
    })
    
    orders.value = Object.values(groupsMap).sort((a,b) => new Date(a.createdAt) - new Date(b.createdAt))
    if (switchView && !isWaiterRole.value) viewMode.value = 'orders'
  } catch (err) {
    console.error('Failed to fetch orders:', err)
    orders.value = []
    if (switchView && !isWaiterRole.value) viewMode.value = 'orders'
  }
}

async function handleOrdersButtonClick() {
  if (isWaiterRole.value && showWaiterOrderCards.value) {
    resetWaiterOrderCardsLeftSide()
    return
  }
  clearBillAreaOnly()
  if (isWaiterRole.value) {
    await fetchOrders(false)
    await nextTick()
    if (waiterMyOrderCards.value.length === 0) {
      showWaiterOrderCards.value = false
      showToast('No Orders found', 'error')
      return
    }
    showWaiterOrderCards.value = true
    viewMode.value = 'bill'
    return
  }
  showWaiterOrderCards.value = false
  await fetchOrders(true)
}

async function handleAllOrdersWaiterSelect() {
  if (!allOrdersWaiterFilter.value || isWaiterRole.value) return
  clearBillAreaOnly()
  showWaiterOrderCards.value = false
  await fetchOrders(true)
}

function formatWaiterOrderCardDate(createdAt) {
  if (!createdAt) return '---'
  const datePart = String(createdAt).split('T')[0]
  const timePart = new Date(createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  return `${datePart} ${timePart}`
}

function isBeforeTodayOrderCard(order) {
  return beforeTodayOrders.value.includes(order)
}

function getWaiterOrderCardItems(order) {
  if (!order || !Array.isArray(order.items)) return []
  const displayedItems = []
  order.items.forEach(i => {
    const iMenuId = String(i.menuId ?? i.menu?.id ?? '')
    const excludeKey = String(i.excludeIngredients || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .join(',')
    const noteKey = String(i.note || '').trim()
    const hasPendingTransfer = Array.isArray(i.transfers) && i.transfers.some(t => t.isAccepted === 0)
    const hasAcceptedTransfer = Array.isArray(i.transfers) && i.transfers.some(t => Number(t.isAccepted) === 1)
    const existing = displayedItems.find(mi =>
      String(mi.menuId ?? '') === iMenuId &&
      mi.excludeKey === excludeKey &&
      mi.noteKey === noteKey
    )
    const qtyToAdd = Number(i.quantity ?? i.qty ?? 0) || 0
    const unitPrice = Number(
      i.unit_price ?? i.unitPrice ?? i.menu?.totalPrice ?? i.menu?.total_price ?? 0
    ) || 0
    if (existing) {
      existing.qty += qtyToAdd
      if (hasPendingTransfer) existing.hasPendingTransfer = true
      if (hasAcceptedTransfer) existing.hasAcceptedTransfer = true
    } else {
      displayedItems.push({
        localId: `card-${order.id}-${i.itemId || i.id || Math.random()}`,
        menuId: iMenuId,
        name: i.name || i.menu?.name || 'Item',
        qty: qtyToAdd,
        unitPrice,
        excludeKey,
        noteKey,
        price: Number(i.price ?? 0) || 0,
        addition: Number(i.addition ?? 0) || 0,
        vat: Number(i.vat ?? 0) || 0,
        hasPendingTransfer,
        hasAcceptedTransfer
      })
    }
  })
  return displayedItems
}

function clearHoveredAllOrder() {
  hoveredAllOrder.value = null
}

function updateHoveredAllOrderPosition(rowEl) {
  if (!rowEl || typeof rowEl.getBoundingClientRect !== 'function') return
  const rect = rowEl.getBoundingClientRect()
  const margin = 8
  const preferLeft = rect.left > 180
  const viewportH = window.innerHeight

  let top = Math.max(margin, rect.top)

  hoveredAllOrderStyle.value = {
    top: `${top}px`,
    left: preferLeft ? `${rect.left - 8}px` : `${rect.right + 8}px`,
    transform: preferLeft ? 'translateX(-100%)' : 'none'
  }

  nextTick(() => {
    const tip = hoveredAllOrderEl.value
    if (!tip) return
    const tipRect = tip.getBoundingClientRect()
    // If cropped at bottom, open from the top of the screen (no scroll)
    if (tipRect.bottom > viewportH - margin) {
      hoveredAllOrderStyle.value = {
        ...hoveredAllOrderStyle.value,
        top: `${margin}px`
      }
    }
  })
}

function onAllOrderRowEnter(order, event) {
  hoveredAllOrder.value = order
  updateHoveredAllOrderPosition(event?.currentTarget)
}

function onAllOrderRowClick(orderId) {
  clearHoveredAllOrder()
  viewOrder(orderId)
}

function getWaiterOrderCardAmounts(order) {
  const totals = { baseAmt: 0, additionalAmt: 0, taxAmt: 0, grandTotal: 0 }
  if (!Array.isArray(order?.items)) {
    return {
      baseAmt: '0.00',
      additionalAmt: '0.00',
      taxAmt: '0.00',
      grandTotal: '0.00'
    }
  }
  order.items.forEach(i => {
    const qty = Number(i.quantity ?? i.qty ?? 0) || 0
    totals.baseAmt += (Number(i.price ?? 0) || 0) * qty
    totals.additionalAmt += (Number(i.addition ?? 0) || 0) * qty
    totals.taxAmt += (Number(i.vat ?? 0) || 0) * qty
    totals.grandTotal += (Number(i.unit_price ?? i.unitPrice ?? 0) || 0) * qty
  })
  return {
    baseAmt: totals.baseAmt.toFixed(2),
    additionalAmt: totals.additionalAmt.toFixed(2),
    taxAmt: totals.taxAmt.toFixed(2),
    grandTotal: totals.grandTotal.toFixed(2)
  }
}

function resetWaiterOrderCardsLeftSide() {
  showWaiterOrderCards.value = false
  allOrdersWaiterFilter.value = ''
  selectedDept.value = null
  selectedSub.value = null
  searchTerm.value = ''
}

function scrollPosPageToTop() {
  const mainEl = document.querySelector('main.flex-1.overflow-y-auto')
  if (mainEl) mainEl.scrollTop = 0
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

function editWaiterOrderCard(orderId) {
  resetWaiterOrderCardsLeftSide()
  viewOrder(orderId)
  nextTick(() => {
    scrollPosPageToTop()
    // Re-run after layout settles (cards hide, bill panel shows)
    requestAnimationFrame(() => scrollPosPageToTop())
  })
}

function scanWaiterOrderCard(orderId) {
  // Keep My Orders cards visible; only load order context for payment scan
  viewOrder(orderId)
  openScanPaymentModal()
}

const sortedBillItems = computed(() => {
  const existingItems = billItems.value.filter(item => item.itemId || item.transferredItemId)
  const newItems = billItems.value.filter(item => !item.itemId && !item.transferredItemId)

  const sortedExisting = [...existingItems].sort((a, b) => {
    const nameA = (a.menu?.name || '').toLowerCase()
    const nameB = (b.menu?.name || '').toLowerCase()
    return nameA.localeCompare(nameB)
  })

  return [...newItems.reverse(), ...sortedExisting]
})

function selectDept(dept) {
  selectedDept.value = dept
  // When department is clicked, clear sub selection so we see ALL menus of that department
  selectedSub.value = null
}

function selectSub(sub) {
  selectedSub.value = sub
}

const filteredMenus = computed(() => {
  // 1. First, only consider menus that are active (status=1)
  const activeMenus = menus.value.filter(m => (m.status === 1 || m.status === undefined))

  // 2. If no department selected AND no search term, show nothing (welcome message)
  if (!selectedDept.value && !searchTerm.value) {
    return []
  }

  // 3. Apply search or category filters
  let result = []
  if (searchTerm.value) {
    // Search across all active menus
    const term = searchTerm.value.toLowerCase()
    result = activeMenus.filter(m => 
      m.name.toLowerCase().includes(term) || 
      (m.code && m.code.toLowerCase().includes(term))
    )
  } else if (selectedSub.value) {
    // Filter active menus by sub-department
    const subId = selectedSub.value.id
    result = activeMenus.filter(m => {
      const menuSubId = m.subDepartmentId ?? m.sub_department_id ?? m.subDeptId ?? m.sub_dept_id
      return menuSubId === subId
    })
  } else if (selectedDept.value) {
    // Filter active menus by department
    const deptId = selectedDept.value.id
    result = activeMenus.filter(m => {
      const menuDeptId = m.departmentId ?? m.department_id ?? m.deptId ?? m.dept_id
      return menuDeptId === deptId
    })
  }

  return result.slice().sort((a, b) =>
    (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
  )
})

function addToBill(menu) {
  // Strict Ownership Check: Only the designated waiter can add items to an existing bill.
  if (currentEditingOrderId.value && !isOwnOrder.value) {
    showToast('You cannot add items to another waiter\'s order', 'error')
    return
  }

  // Auto-switch to bill view
  viewMode.value = 'bill'
  printFailures.value = []

  // Merge ONLY with an existing 'new' item (unsaved, no database IDs)
  const existingNew = billItems.value.find(b => 
    !b.itemId && !b.transferredItemId &&
    b.menu.id === menu.id && 
    (b.note || '') === '' && 
    (b.excludeIngredients || '') === ''
  )
  if (existingNew) {
    existingNew.qty++
    existingNew.ownNotPrintedCount = (existingNew.ownNotPrintedCount || 0) + 1
    existingNew.notPrintedCount = (existingNew.notPrintedCount || 0) + 1
    existingNew.ownQty = (existingNew.ownQty || 0) + 1
    return
  }
  const recipeIngs = menu.recipes?.recipe_ingredients || []
  const activeIngs = recipeIngs.filter(ri => ri.is_active === 1).map(ri => ({
    id: ri.id,
    name: ri.items?.itemName || ri.item?.name || ri.products?.name || ri.product?.name || 'Unknown',
    checked: true
  }))
  billItems.value.push({ 
    localId: `local-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
    menu, 
    qty: 1,
    originalQty: 0,
    orderId: null,
    orderNumber: null,
    excludeIngredients: '',
    ingredients: activeIngs,
    isExpanded: false,
    selected: false,
    note: '',
    transferredNotPrintedCount: 0,
    ownNotPrintedCount: 1,
    notPrintedCount: 1, // Truly new quantity
    isAcceptedTransfer: false,
    transferredItemId: undefined,
    transferredQty: 0,
    ownQty: 1
  })
}

async function removeFromBill(item) {
  if (!item) return

  const idsToDelete = [...new Set([item.itemId, item.transferredItemId].filter(Boolean))]
  if (idsToDelete.length > 0 && blockIfOrderGroupHasPendingTransfer()) return

  const confirmMsg = `Are you sure you want to remove ${item.menu.name}?`
  if (!window.confirm(confirmMsg)) return

  // Identify all saved item IDs (own and transferred)

  if (idsToDelete.length > 0) {
    if (!canVoidOrder.value) {
      showToast('You do not have privilege to remove saved items.', 'error')
      return
    }
    try {
      const response = await apiFetch('/orders/bulk-delete', {
        method: 'DELETE',
        body: JSON.stringify({
          orderIds: idsToDelete,
          adminId: currentUser.value?.id,
          adminName: currentUser.value?.full_name || currentUser.value?.username || null,
          orderUpdatedAt: getOrderUpdatedAtForGroup(),
        })
      })
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}))
        throw new Error(errorData.message || 'Failed to delete item.')
      }
      const deletedIds = new Set(idsToDelete.map(id => String(id)))
      editingOrderUpdatedAt.value = editingOrderUpdatedAt.value.filter(
        entry => !deletedIds.has(String(entry.id))
      )
      showToast('Item removed successfully', 'success')
    } catch (err) {
      console.error('Failed to delete item:', err)
      const isSecurityLock = err.message && err.message.includes('System security lock')
      showToast(err.message || 'Failed to delete item.', 'error', isSecurityLock ? 10000 : 3000)
      return
    }
  }

  const idx = billItems.value.indexOf(item)
  if (idx !== -1) {
    billItems.value.splice(idx, 1)
  }

  // If the last item was removed, reset the bill state
  if (billItems.value.length === 0) {
    clearBill(true)
  }
}

async function changeQty(item, newQty) {
  if (!item) return

  const parsedQty = Number(newQty)
  const isExisting = !!(item.itemId || item.transferredItemId)

  // New (unsaved) items only: support +/- and manual Qty entry.
  // Manual input uses v-model, so item.qty may already equal newQty (delta would be 0)
  // and the old decrease path would incorrectly zero ownQty → empty items on send.
  if (!isExisting) {
    if (!Number.isFinite(parsedQty) || parsedQty < 1) {
      item.qty = Math.max(1, Number(item.ownQty) || 1)
      showToast('Minimum quantity is 1. Please use the delete button to remove items.', 'error')
      return
    }
    item.qty = parsedQty
    item.ownQty = parsedQty
    item.ownNotPrintedCount = parsedQty
    item.notPrintedCount = parsedQty + (Number(item.transferredNotPrintedCount) || 0)
    return
  }

  if (!Number.isFinite(parsedQty) || parsedQty < 1) {
    showToast('Minimum quantity is 1. Please use the delete button to remove items.', 'error')
    return
  }

  const delta = parsedQty - item.qty

  if (delta > 0) {
    // Increase: Always adds to 'own' share
    item.qty = parsedQty
    item.ownQty = (item.ownQty || 0) + delta
    item.ownNotPrintedCount = (item.ownNotPrintedCount || 0) + delta
    item.notPrintedCount = (item.ownNotPrintedCount || 0) + (item.transferredNotPrintedCount || 0)
    return
  }

  // Decrease (saved items only — input is readonly for these):
  if (blockIfOrderGroupHasPendingTransfer()) return
  if (!window.confirm(`Are you sure you want to decrease the quantity of ${item.menu.name}?`)) return

  try {
    const adminId = currentUser.value?.id
    const adminName = currentUser.value?.full_name || currentUser.value?.username || 'System'

    // Priority: Decrease from 'own' shares first
    if ((item.ownQty || 0) > 0) {
      const newOwnQty = item.ownQty - 1
      const newOwnNotPrintedCount = Math.max(0, (item.ownNotPrintedCount || 0) - 1)

      if (item.itemId) {
        const response = await apiFetch(`/orders/${item.itemId}`, {
          method: 'PATCH',
          body: JSON.stringify({ 
            newQty: newOwnQty, 
            newNotPrintedCount: newOwnNotPrintedCount, 
            adminId, 
            adminName,
            orderUpdatedAt: getOrderUpdatedAtForGroup(),
          })
        })
        const responseData = await response.json().catch(() => ({}))
        if (!response.ok) throw new Error(responseData.message || 'Failed to update quantity.')
        updateLoadedOrderUpdatedAt(item.itemId, responseData.updatedAt)
      }
      item.ownQty = newOwnQty
      item.ownNotPrintedCount = newOwnNotPrintedCount
        if (item.itemId)
      showToast('Quantity decreased from '+item.menu.name, 'success')
    } 
    // If own is exhausted, decrease from transferred share
    else if ((item.transferredQty || 0) > 1) {
      const newTransferredQty = item.transferredQty - 1
      const newTransferredNotPrintedCount = Math.max(0, (item.transferredNotPrintedCount || 0) - 1)

      if (item.transferredItemId) {
        const response = await apiFetch(`/orders/${item.transferredItemId}`, {
          method: 'PATCH',
          body: JSON.stringify({ 
            newQty: newTransferredQty, 
            newNotPrintedCount: newTransferredNotPrintedCount, 
            adminId, 
            adminName,
            orderUpdatedAt: getOrderUpdatedAtForGroup(),
          })
        })
        const responseData = await response.json().catch(() => ({}))
        if (!response.ok) throw new Error(responseData.message || 'Failed to update quantity.')
        updateLoadedOrderUpdatedAt(item.transferredItemId, responseData.updatedAt)
      }

      item.transferredQty = newTransferredQty
      item.transferredNotPrintedCount = newTransferredNotPrintedCount
      showToast('Quantity decreased from transferred share', 'success')
    }

    // Sync total counts
    item.qty = parsedQty
    item.notPrintedCount = (item.ownNotPrintedCount || 0) + (item.transferredNotPrintedCount || 0)

  } catch (err) {
    console.error('Failed to update quantity:', err)
    const isSecurityLock = err.message && err.message.includes('System security lock')
    showToast(err.message || 'Failed to update quantity.', 'error', isSecurityLock ? 10000 : 3000)
    // Optionally: fetchOrders() here to resync UI with database if something went wrong
  }
}


function toggleExpansion(item) {
  const targetState = !item.isExpanded
  if (targetState) {
    billItems.value.forEach(i => { i.isExpanded = false })
  }
  item.isExpanded = targetState
}

function appendTableNumber(digit) {
  tableNumber.value += digit.toString()
  tableError.value = false
}

async function clearBill(skipConfirm = false) {
  if (currentEditingOrderId.value && blockIfOrderGroupHasPendingTransfer()) return

  // strictly check skipConfirm is not true/truthy event
  if (skipConfirm !== true && billItems.value.length > 0) {
    const isActuallyEditing = currentEditingOrderId.value && currentEditingOrderId.value !== 'null'
    const msg = isActuallyEditing
      ? "Are you sure you want to DELETE this entire order from the database?" 
      : "Are you sure you want to clear the current bill?"
    
    if (!window.confirm(msg)) return

    if (isActuallyEditing) {
      if (!canVoidOrder.value) {
        showToast('You do not have privilege to delete this order.', 'error')
        return
      }
      try {
        const response = await apiFetch(`/orders/group/${currentEditingOrderId.value}`, {
          method: 'DELETE',
          body: JSON.stringify({
            adminId: currentUser.value?.id,
            adminName: currentUser.value?.full_name || currentUser.value?.username || null,
            orderUpdatedAt: getOrderUpdatedAtForGroup(),
          })
        })
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}))
          throw new Error(errorData.message || 'Failed to delete order.')
        }
        // Remove from local orders list for immediate UI update
        if (Array.isArray(orders.value)) {
          orders.value = orders.value.filter(o => 
            o.id !== currentEditingOrderId.value && 
            o.orderGroupId !== currentEditingOrderId.value &&
            o.createdAt !== currentEditingOrderId.value
          )
        }
        showToast('Order deleted successfully', 'success')
      } catch (err) {
        console.error('Failed to delete order group:', err)
        const isSecurityLock = err.message && err.message.includes('System security lock')
        showToast(err.message || 'Failed to delete order.', 'error', isSecurityLock ? 10000 : 3000)
        return
      }
    }
  }

  const billWasEmpty = billItems.value.length === 0
  billItems.value = []
  
  if (!skipConfirm || billWasEmpty) {
    printFailures.value = []
  }

  tableNumber.value = ''
  tableError.value = false
  currentEditingOrderId.value = null
  editingOrderUpdatedAt.value = []
  originalWaiterId.value = null
  selectedOrderDate.value = ''
  isDelivery.value = false
  deliveryCompany.value = ''
  deliveryCode.value = ''
  showPaymentModal.value = false
  paymentPhase.value = 'selection'
  selectedPaymentMethod.value = null
  customerPhone.value = ''
  transactionId.value = ''
  scannedReceiverDisplay.value = ''
  // Keep waiter as the logged-in user
  if (currentUser.value) {
    selectedWaiter.value = currentUser.value.full_name || currentUser.value.username || ''
  }
}

function clearBillAreaOnly() {
  // Clear UI only: no API calls, no logs, no confirmations.
  billItems.value = []
  printFailures.value = []

  tableNumber.value = ''
  tableError.value = false

  currentEditingOrderId.value = null
  editingOrderUpdatedAt.value = []
  originalWaiterId.value = null
  selectedOrderDate.value = ''

  isDelivery.value = false
  deliveryCompany.value = ''
  deliveryCode.value = ''

  showPaymentModal.value = false
  paymentPhase.value = 'selection'
  selectedPaymentMethod.value = null
  customerPhone.value = ''
  transactionId.value = ''
  scannedReceiverDisplay.value = ''

  // Keep waiter as the logged-in user
  if (currentUser.value) {
    selectedWaiter.value = currentUser.value.full_name || currentUser.value.username || ''
  }
}

function handleBackOrClear() {
  // Back while editing should only clear the bill area (no DB delete, no log, no confirm)
  if (currentEditingOrderId.value && currentEditingOrderId.value !== 'null') {
    clearBillAreaOnly()
  } else {
    // Skip confirmation for simply clearing an unsaved bill
    clearBill(true)
  }
  if (showWaiterOrderCards.value) {
    resetWaiterOrderCardsLeftSide()
  }
}

// getMergedItems is no longer needed as we support individual rows

function resolveOrderTableNumber() {
  const trimmedTable = String(tableNumber.value ?? '').trim()
  if (trimmedTable) return trimmedTable
  if (isDelivery.value) {
    const code = String(deliveryCode.value ?? '').trim()
    if (code) return `Code-${code}`
  }
  if (isTableMandatory.value === 0) {
    return Date.now().toString()
  }
  return ''
}

async function sendOrder() {
  if (billItems.value.length === 0 || isSending.value) return
  if (currentEditingOrderId.value && blockIfOrderGroupHasPendingTransfer()) return
  isSending.value = true
  printFailures.value = []
  try {
  if (isTableMandatory.value === 1 && !tableNumber.value && !isDelivery.value) {
    tableError.value = true
    return
  }
  tableError.value = false
  syncExcludes()
  
  const orderGroupId = currentEditingOrderId.value || `pos-${Date.now()}-${Math.floor(Math.random() * 1000)}`

  if (isDelivery.value && (!deliveryCompany.value || !deliveryCode.value)) {
    showToast('Please select delivery company and enter code.', 'error')
    isSending.value = false
    return
  }

  const resolvedTableNumber = resolveOrderTableNumber()

  // TABLE VALIDATION: Check if table number already exists in pending (for this waiter)
  if (!isDelivery.value && !currentEditingOrderId.value && tableNumber.value) {
    const todayDate = new Date().toISOString().split('T')[0] // YYYY-MM-DD
    const tableExists = orders.value.some(o => 
      o.isPaid !== 1 && 
      String(o.table) === String(tableNumber.value) &&
      String(o.waiterId) === String(currentUser.value?.id) &&
      (o.createdAt ? String(o.createdAt).split('T')[0] : '') === todayDate &&
      String(o.id) !== String(currentEditingOrderId.value)
    )
    if (tableExists) {
      showToast('Table number already exists in pending.', 'error')
      isSending.value = false
      tableNumber.value=""
      return
    }
  }

  const itemsToSave = []
  billItems.value.forEach(item => {
    const deptId = item.menu.departmentId ?? item.menu.department_id ?? item.menu.deptId ?? item.menu.dept_id;
    const dept = departments.value.find(d => d.id === deptId);
    const printerIP = dept ? dept.printerIP : null;
    const departmentName = dept ? dept.name : 'Unknown Department';
    const howManyCopies = dept ? (Number(dept.how_many_copies ?? dept.howManyCopies ?? 1) || 1) : 1;

    const baseItem = {
      menuId: item.menuId ?? item.menu?.id,
      companyId: companyId.value,
      branchId: branchId.value,
      waiterId: currentEditingOrderId.value ? (originalWaiterId.value || currentUser.value?.id) : (currentUser.value?.id || null),
      tableNumber: resolvedTableNumber,
      unitPrice: item.menu.totalPrice,
      // Preserve the originally created values; never overwrite with zeros.
      price: Number(item.menu.price ?? item.price ?? 0) || 0,
      addition: Number(item.menu.addition ?? item.addition ?? 0) || 0,
      vat: Number(item.menu.vat ?? item.vat ?? 0) || 0,
      excludeIngredients: item.excludeIngredients,
      note: item.note,
      ingredient_and_amount: buildOrderIngredientAndAmount(item),
      isPaid: 0,
      orderGroupId: orderGroupId,
      deliveryId: isDelivery.value ? String(deliveryCompany.value) : null,
      deliveryCode: isDelivery.value ? deliveryCode.value : null,
      companyName: companyName.value || null,
      printerIP: printerIP,
      departmentName: departmentName,
      departmentId: deptId ?? null,
      howManyCopies: howManyCopies,
      isForStaff: 'Normal'
    }

    if (item.transferredQty > 0) {
      itemsToSave.push({ 
        ...baseItem, 
        itemId: item.transferredItemId || null,
        quantity: item.transferredQty, 
        totalPrice: item.transferredQty * item.menu.totalPrice,
        isAcceptedTransfer: 1,
        not_printed_count: item.transferredNotPrintedCount || 0
      })
    }
    if (item.ownQty > 0) {
      itemsToSave.push({ 
        ...baseItem, 
        itemId: item.itemId || null,
        waiterId: item.itemId ? (originalWaiterId.value || currentUser.value?.id) : (currentUser.value?.id || originalWaiterId.value || null),
        quantity: item.ownQty, 
        totalPrice: item.ownQty * item.menu.totalPrice,
        isAcceptedTransfer: 0,
        not_printed_count: item.ownNotPrintedCount || 0
      })
    }
  })

  try {
    const rawResponse = await apiFetch('/orders', {
      method: 'POST',
      body: JSON.stringify({
        items: itemsToSave,
        orderUpdatedAt: getOrderUpdatedAtForGroup(orderGroupId),
        isOrderUpdate: Boolean(currentEditingOrderId.value),
      }),
    })
    if (!rawResponse.ok) {
      const errorData = await rawResponse.json().catch(() => ({}))
      throw new Error(errorData.message || 'Server error')
    }
    const response = await rawResponse.json().catch(() => ({}))

    if (response && response.printFailures && response.printFailures.length > 0) {
      printFailures.value = response.printFailures
      showToast(response.message || `Printing failed for: ${response.printFailures.join(', ')}`, 'error')
      await fetchOrders(false)
      const reloadId = currentEditingOrderId.value || orderGroupId
      if (!currentEditingOrderId.value) {
        currentEditingOrderId.value = reloadId
      }
      viewOrder(reloadId)
      billItems.value = billItems.value.filter(item =>
        (Number(item.notPrintedCount) || 0) > 0
        || (Number(item.ownNotPrintedCount) || 0) > 0
        || (Number(item.transferredNotPrintedCount) || 0) > 0
      )
      return
    }

    showToast(currentEditingOrderId.value ? 'Order updated successfully' : 'Order sent successfully', 'success')
  } catch (err) { 
    console.error('DB Persistence Failed', err) 
    const isSecurityLock = err.message && err.message.includes('Date and time issue')
    showToast(err.message || 'Failed to save order.', 'error', isSecurityLock ? 60000 : 3000)
    return
  }

  if (currentEditingOrderId.value) {
    const idx = orders.value.findIndex(o => o.id === currentEditingOrderId.value)
    if (idx !== -1) {
      orders.value[idx].items = normalizeOrderItemsForCache(billItems.value)
      orders.value[idx].table = resolvedTableNumber
      orders.value[idx].isDelivery = isDelivery.value
      orders.value[idx].deliveryId = isDelivery.value ? String(deliveryCompany.value) : null
      orders.value[idx].deliveryCode = isDelivery.value ? deliveryCode.value : null
    }
  } else {
    const orderId = orderGroupId
    const orderNumber = orders.value.length + 1
    orders.value.push({
      id: orderId,
      orderNumber: orderNumber,
      createdAt: new Date().toISOString(),
      waiterName: selectedWaiter.value,
      waiterId: currentUser.value?.id,
      table: resolvedTableNumber,
      isPaid: 0,
      isDelivery: isDelivery.value,
      deliveryId: isDelivery.value ? String(deliveryCompany.value) : null,
      deliveryCode: isDelivery.value ? deliveryCode.value : null,
      items: normalizeOrderItemsForCache(billItems.value),
      orderGroupId: orderGroupId,
      note: billItems.value.map(item => item.note).join(', '), // Assuming note is aggregated or taken from first item
      tableNumber: resolvedTableNumber,
    })
  }

  clearBill(true)
  await fetchOrders(false)
  persistOrders()
  } finally {
    isSending.value = false
  }
}


function handlePaymentSelection(method) {
  selectedPaymentMethod.value = method
  scannedReceiverDisplay.value = ''
  const isCash = method.name?.toLowerCase() === 'cash' || method.name?.toLowerCase() === 'delivery'
  
  if (isCash) {
    markPaid(method)
  } else {
    paymentPhase.value = 'details'
    if (isCbeMethod(normalizePaymentMethodName(method))) {
      nextTick(() => openHostedCbeScanner())
    }
  }
}

async function markPaid(paymentMethod = 'Cash') {
  if (billItems.value.length === 0 || isSending.value) return
  isSending.value = true
  try {
    if (isTableMandatory.value === 1 && !tableNumber.value && !isDelivery.value) {
      tableError.value = true
      return
    }
    tableError.value = false
  syncExcludes()
  
  if (isDelivery.value && (!deliveryCompany.value || !deliveryCode.value)) {
    showToast('Please select delivery company and enter code.', 'error')
    isSending.value = false
    return
  }

  const methodObj = typeof paymentMethod === 'string' ? { name: paymentMethod } : paymentMethod
  const isCash = methodObj.name?.toLowerCase() === 'cash' || methodObj.name?.toLowerCase() === 'delivery'
  const methodName = methodObj.name || 'Cash'

  const paymentMethodToSave = isCash
    ? methodName
    : `${methodName}, ${customerPhone.value.trim()}, ${transactionId.value.trim()}`

  const orderGroupId = currentEditingOrderId.value
  if (!orderGroupId || orderGroupId === 'null') {
    showToast('Open an existing order from the list before confirming payment.', 'error')
    return
  }

  try {
    const rawResponse = await apiFetch(`/orders/group/${encodeURIComponent(orderGroupId)}/confirm`, {
      method: 'PATCH',
      body: JSON.stringify({
        paymentMethod: paymentMethodToSave,
        deliveryId: isDelivery.value ? String(deliveryCompany.value) : null,
        deliveryCode: isDelivery.value ? deliveryCode.value : null,
        companyId: companyId.value,
        branchId: branchId.value,
        orderUpdatedAt: getOrderUpdatedAtForGroup(orderGroupId),
      }),
    })
    if (!rawResponse.ok) {
      const errorData = await rawResponse.json().catch(() => ({}))
      throw new Error(errorData.message || 'Server error')
    }

    showToast('Payment processed successfully', 'success')
  } catch (err) { 
    console.error('DB Persistence Failed', err)
    const isSecurityLock = err.message && err.message.includes('System security lock')
    showToast(err.message || 'Failed to process payment.', 'error', isSecurityLock ? 10000 : 3000)
    return
  }

  const idx = orders.value.findIndex(o => o.id === orderGroupId)
  if (idx !== -1) {
    orders.value[idx].items = normalizeOrderItemsForCache(billItems.value)
    orders.value[idx].isPaid = 1
    orders.value[idx].paymentMethod = paymentMethodToSave
    orders.value[idx].customerPhone = customerPhone.value
    orders.value[idx].deliveryId = isDelivery.value ? String(deliveryCompany.value) : null
    orders.value[idx].deliveryCode = isDelivery.value ? deliveryCode.value : null
  }

  clearBill(true)
  await fetchOrders(false)
  persistOrders()
  } finally {
    isSending.value = false
  }
}

function confirmBill() {
  if (billItems.value.length === 0) return
  if (!canConfirmOrder.value) {
    showToast('You do not have privilege to confirm orders.', 'error')
    return
  }
  // if (!canClickConfirmBill.value) return
  if (isTableMandatory.value === 1 && !tableNumber.value && !isDelivery.value) {
    tableError.value = true
    return
  }

 if( currentEditingOrderId.value!==null && currentEditingOrderId.value!=="null") {
  paymentModalPurpose.value = 'confirm'
  paymentPhase.value = 'selection'
  selectedPaymentMethod.value = null
  showPaymentModal.value = true
 }
}

function openScanPaymentModal() {
  if (billItems.value.length === 0) {
    showToast('Add items to the bill before scanning payment.', 'error')
    return
  }
  if (isTableMandatory.value === 1 && !tableNumber.value && !isDelivery.value) {
    tableError.value = true
    return
  }
  if (!currentEditingOrderId.value || currentEditingOrderId.value === 'null') {
    showToast('Open an existing order from the list before scanning payment.', 'error')
    return
  }

  paymentModalPurpose.value = 'scan'
  paymentPhase.value = 'selection'
  selectedPaymentMethod.value = null
  showPaymentModal.value = true
}


function getBillItemAmountParts(b) {
  const toNum = (v) => {
    const n = Number(v)
    return Number.isFinite(n) ? n : 0
  }
  const qty = toNum(b?.qty ?? b?.quantity)
  const unitPrice = toNum(b?.menu?.price ?? b?.price ?? 0)
  const unitAddition = toNum(b?.menu?.addition ?? b?.addition ?? 0)
  const unitVat = toNum(b?.menu?.vat ?? b?.vat ?? 0)
  const unitTotal = toNum(
    b?.menu?.totalPrice ??
    b?.menu?.total_price ??
    b?.unit_price ??
    b?.unitPrice ??
    b?.totalPrice ??
    b?.total_price
  )
  return {
    base: unitPrice * qty,
    addition: unitAddition * qty,
    vat: unitVat * qty,
    grand: unitTotal * qty
  }
}

const billAmountSummary = computed(() => {
  const totals = billItems.value.reduce(
    (acc, item) => {
      const parts = getBillItemAmountParts(item)
      acc.baseAmt += parts.base
      acc.additionalAmt += parts.addition
      acc.taxAmt += parts.vat
      acc.grandTotal += parts.grand
      return acc
    },
    { baseAmt: 0, additionalAmt: 0, taxAmt: 0, grandTotal: 0 }
  )
  return {
    baseAmt: totals.baseAmt.toFixed(2),
    additionalAmt: totals.additionalAmt.toFixed(2),
    taxAmt: totals.taxAmt.toFixed(2),
    grandTotal: totals.grandTotal.toFixed(2)
  }
})

const totalPrice = computed(() => billAmountSummary.value.grandTotal)

function formatPaymentTotal(value) {
  const amount = Number(value)
  return Number.isFinite(amount)
    ? amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : String(value ?? '')
}

const orderGroups = computed(() => {
  const groupsMap = {}
  if (!Array.isArray(orders.value)) return []

  const uid = currentUser.value?.id || currentUser.value?.sub
  orders.value.filter(o => o && o.isPaid !== 1 && (o.transferStatus !== 0 || String(o.waiterId) === String(uid))).forEach(o => {
    const key = o.id || o.createdAt || Math.random().toString()
    if (!groupsMap[key]) {
      const wName = o.waiterName || o.waiter || ''
      const firstName = wName.split(' ')[0]
      groupsMap[key] = { 
        ...o, 
        waiterName: firstName || 'System',
        totalPriceSum: 0 
      }
    }
    if (Array.isArray(o.items)) {
      const priceSum = o.items.reduce((a, i) => a + (Number(i.qty) || 0) * (Number(i.unitPrice) || 0), 0)
      groupsMap[key].totalPriceSum += priceSum
      
      // Check if any item in this group has unprinted quantity
      const hasUnprinted = o.items.some(i => (Number(i.not_printed_count || i.notPrintedCount) || 0) > 0)
      if (hasUnprinted) {
        groupsMap[key].isAnyUnprinted = true
      }
    }
  })
  return Object.values(groupsMap).sort((a,b) => new Date(a.createdAt) - new Date(b.createdAt))
})

const todayOrders = computed(() => {
  const today = new Date().toISOString().split('T')[0]
  const filtered = orderGroups.value.filter(o => {
    const orderDate = o.createdAt ? String(o.createdAt).split('T')[0] : ''
    return orderDate === today
  })

  // Deduplicate by (waiterId + table) for the "All orders" list.
  // Prefer accepted/merged groups (transferStatus === 1) when duplicates exist.
  const byKey = new Map()
  filtered.forEach(o => {
    const k = `${String(o.waiterId ?? '')}|${String(o.table ?? '')}`
    const prev = byKey.get(k)
    if (!prev) {
      byKey.set(k, o)
      return
    }
    const prevAccepted = prev.transferStatus === 1
    const oAccepted = o.transferStatus === 1
    if (oAccepted && !prevAccepted) {
      byKey.set(k, o)
      return
    }
    // If both are accepted (or both not accepted), keep the latest by createdAt.
    const prevTime = prev.createdAt ? new Date(prev.createdAt).getTime() : 0
    const oTime = o.createdAt ? new Date(o.createdAt).getTime() : 0
    if (oTime > prevTime) byKey.set(k, o)
  })

  return Array.from(byKey.values()).sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
})

const beforeTodayOrders = computed(() => {
  const today = new Date().toISOString().split('T')[0]
  const filtered = orderGroups.value.filter(o => {
    const orderDate = o.createdAt ? String(o.createdAt).split('T')[0] : ''
    return orderDate && orderDate < today
  })

  // Same dedupe rule for the "Before Today Orders" list.
  const byKey = new Map()
  filtered.forEach(o => {
    const k = `${String(o.waiterId ?? '')}|${String(o.table ?? '')}|${o.createdAt ? String(o.createdAt).split('T')[0] : ''}`
    const prev = byKey.get(k)
    if (!prev) {
      byKey.set(k, o)
      return
    }
    const prevAccepted = prev.transferStatus === 1
    const oAccepted = o.transferStatus === 1
    if (oAccepted && !prevAccepted) {
      byKey.set(k, o)
      return
    }
    const prevTime = prev.createdAt ? new Date(prev.createdAt).getTime() : 0
    const oTime = o.createdAt ? new Date(o.createdAt).getTime() : 0
    if (oTime > prevTime) byKey.set(k, o)
  })

  // Most recent from previous days first
  return Array.from(byKey.values()).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
})

const isEditingBeforeTodayOrder = computed(() => (
  !!currentEditingOrderId.value
  && beforeTodayOrders.value.some(order => String(order.id) === String(currentEditingOrderId.value))
))

const isEditingOtherWaiterOrder = computed(() => {
  if (!currentEditingOrderId.value) return false
  const order = orders.value.find(item => String(item.id) === String(currentEditingOrderId.value))
  const waiterId = order?.waiterId ?? order?.waiter_id ?? originalWaiterId.value
  const userId = currentUser.value?.id ?? currentUser.value?.sub
  return waiterId != null && userId != null && String(waiterId) !== String(userId)
})

// All Orders list filter (Select Waiter) — does not change todayOrders/beforeTodayOrders used elsewhere
const filteredTodayOrders = computed(() => {
  if (!allOrdersWaiterFilter.value || allOrdersWaiterFilter.value === '__all__') return todayOrders.value
  return todayOrders.value.filter(o => String(o.waiterId) === String(allOrdersWaiterFilter.value))
})

const filteredBeforeTodayOrders = computed(() => {
  if (!allOrdersWaiterFilter.value || allOrdersWaiterFilter.value === '__all__') return beforeTodayOrders.value
  return beforeTodayOrders.value.filter(o => String(o.waiterId) === String(allOrdersWaiterFilter.value))
})

const waiterMyOrderCards = computed(() => {
  if (!isWaiterRole.value) return []
  return [...todayOrders.value, ...beforeTodayOrders.value].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  )
})

// async function handlePageRefresh() {
//   try {
//     showToast('Refreshing page...', 'success')
//     await Promise.all([
//       loadDepartments(),
//       loadMenus(),
//       loadPaymentMethods(),
//       loadDeliveryCompanies(),
//       fetchOrders(false),
//       loadWaiters(),
//       fetchTransferRequests()
//     ])
//     clearBill(true)
//   } catch (err) {
//     console.error('Refresh failed', err)
//     showToast('Failed to refresh page', 'error')
//   }
// }

function resolveOrderItemMenuId(item) {
  const raw = item?.menuId ?? item?.menu?.id
  if (raw === null || raw === undefined || raw === '') return ''
  return String(raw)
}

function normalizeOrderItemsForCache(items) {
  if (!Array.isArray(items)) return []
  return items.map((item) => {
    const menuId = resolveOrderItemMenuId(item) || null
    const qty = Number(item.quantity ?? item.qty ?? 0) || 0
    return {
      ...item,
      menuId,
      qty,
      quantity: qty,
      menu: item.menu
        ? { ...item.menu, id: item.menu.id ?? menuId }
        : item.menu,
    }
  })
}

function viewOrder(orderId) {
  const o = orders.value.find(x => (x.id === orderId) || (x.createdAt === orderId))
  if (!o) return
  currentEditingOrderId.value = o.id
  editingOrderUpdatedAt.value = (Array.isArray(o.items) ? o.items : []).map(item => ({
    id: item.itemId ?? item.id,
    updatedAt: item.updatedAt,
  }))
  originalWaiterId.value = o.waiterId || null
  
  const displayedItems = []
  o.items.forEach(i => {
    const isAccepted = Array.isArray(i.transfers) && i.transfers.some(t => t.isAccepted === 1 && t.receiverId === currentUser.value?.id)
    const iMenuId = resolveOrderItemMenuId(i)
    const menuObj = menus.value.find(m => String(m.id ?? '') === iMenuId)
    const excludeKey = String(i.excludeIngredients || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .join(',')
    const noteKey = String(i.note || '').trim()
    
    // Merge identical database items for display
    const existing = displayedItems.find(mi => 
      resolveOrderItemMenuId(mi) === iMenuId && 
      String(mi.excludeIngredients || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
        .join(',') === excludeKey && 
      String(mi.note || '').trim() === noteKey
    )
    
    if (existing) {
      const qtyToAdd = Number(i.quantity ?? i.qty ?? 0) || 0
      const npToAdd = (i.not_printed_count || i.notPrintedCount || 0)
      existing.qty += qtyToAdd
      if (isAccepted) {
        existing.transferredQty += qtyToAdd
        existing.transferredNotPrintedCount += npToAdd
        existing.transferredItemId = i.id || i.itemId
      } else {
        existing.ownQty += qtyToAdd
        existing.ownNotPrintedCount += npToAdd
        existing.itemId = i.id || i.itemId
      }
      existing.notPrintedCount += npToAdd
    } else {
      const recipeIngs = menuObj?.recipes?.recipe_ingredients || []
      const excludedList = (i.excludeIngredients || '').split(',').map(s => s.trim()).filter(Boolean)
      const activeIngs = recipeIngs.filter(ri => ri.is_active === 1).map(ri => {
        const name = ri.items?.itemName || ri.item?.name || ri.products?.name || ri.product?.name || 'Unknown'
        return { id: ri.id, name, checked: !excludedList.includes(name) }
      })
      const unitPrice = Number(i.unit_price ?? i.unitPrice ?? 0) || 0
      const savedPrice = Number(i.price ?? 0) || 0
      const savedAddition = Number(i.addition ?? 0) || 0
      const savedVat = Number(i.vat ?? 0) || 0

      const resolvedMenuId = iMenuId || menuObj?.id || i.menu?.id || null
      displayedItems.push({
        localId: `load-${i.id || i.itemId || Math.random()}`,
        menuId: resolvedMenuId,
        itemId: isAccepted ? undefined : (i.id || i.itemId),
        transferredItemId: isAccepted ? (i.id || i.itemId) : undefined,
        menu: {
          ...(menuObj || i.menu),
          id: resolvedMenuId,
          totalPrice: unitPrice,
          price: savedPrice,
          addition: savedAddition,
          vat: savedVat
        },
        unitPrice,
        unit_price: unitPrice,
        qty: Number(i.quantity ?? i.qty ?? 0) || 0,
        transferredQty: isAccepted ? (i.quantity || i.qty) : 0,
        ownQty: isAccepted ? 0 : (i.quantity || i.qty),
        isAcceptedTransfer: isAccepted,
        originalQty: i.quantity || i.qty,
        orderId: o.id,
        orderNumber: o.orderNumber,
        excludeIngredients: i.excludeIngredients || '',
        ingredients: activeIngs,
        isExpanded: false,
        selected: false,
        note: i.note || '',
        transferredNotPrintedCount: isAccepted ? (i.not_printed_count || i.notPrintedCount || 0) : 0,
        ownNotPrintedCount: isAccepted ? 0 : (i.not_printed_count || i.notPrintedCount || 0),
        notPrintedCount: i.not_printed_count || i.notPrintedCount || 0
      })
    }
  })
  billItems.value = displayedItems
  
  tableNumber.value = o.table ? String(o.table) : ''
  selectedWaiter.value = o.waiterName || o.waiter || ''
  isDelivery.value = !!o.isDelivery || o.table === 'Delivery'
  deliveryCompany.value = resolveDeliveryCompanySelection(o.deliveryId || o.deliveryCompany || o.deliveryCompanyName || '')
  deliveryCode.value = o.deliveryCode || ''
  if (o.createdAt) {
    const datePart = o.createdAt.split('T')[0] // YYYY-MM-DD
    const timePart = new Date(o.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    selectedOrderDate.value = `${datePart} ${timePart}`
  } else {
    selectedOrderDate.value = ''
  }
  
  viewMode.value = 'bill'
  nextTick(() => {
    scrollToBottom()
  })
}
</script>

<style scoped>
.txn-scan-file-input {
  position: fixed;
  left: -9999px;
  top: 0;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
}

.txn-qr-scan-frame {
  position: relative;
  width: min(72vw, 260px);
  height: min(72vw, 260px);
  border-radius: 18px;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.45);
}

.txn-qr-corner {
  position: absolute;
  width: 28px;
  height: 28px;
  border: 3px solid #22c55e;
}

.txn-qr-corner-tl {
  top: 0;
  left: 0;
  border-right: 0;
  border-bottom: 0;
  border-top-left-radius: 12px;
}

.txn-qr-corner-tr {
  top: 0;
  right: 0;
  border-left: 0;
  border-bottom: 0;
  border-top-right-radius: 12px;
}

.txn-qr-corner-bl {
  bottom: 0;
  left: 0;
  border-right: 0;
  border-top: 0;
  border-bottom-left-radius: 12px;
}

.txn-qr-corner-br {
  bottom: 0;
  right: 0;
  border-left: 0;
  border-top: 0;
  border-bottom-right-radius: 12px;
}

.txn-qr-scan-line {
  position: absolute;
  left: 12%;
  right: 12%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #4ade80, transparent);
  animation: txn-qr-scan-move 1.8s ease-in-out infinite;
}

@keyframes txn-qr-scan-move {
  0% { top: 12%; opacity: 0.35; }
  50% { opacity: 1; }
  100% { top: 86%; opacity: 0.35; }
}

.waiter-card-item-name {
  display: block;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

input[type=number].no-spinner::-webkit-outer-spin-button,
input[type=number].no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number].no-spinner {
  appearance: textfield;
  -moz-appearance: textfield;
}

/* TABLE STYLE (same as first component) */

table {
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.75rem;
  color: #1e293b;
}

th,
td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

th {
  background: #f1f5f9;
  cursor: default;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 20;
}

.recipe-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}



.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f5f9;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Modal Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Chrome, Safari, Edge, Opera */
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.no-spinner {
  appearance: textfield;
  -moz-appearance: textfield;
}
/* Toast Transitions */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.toast-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.txn-scan-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(13, 65, 105, 0.2);
  border-radius: 50%;
  border-top-color: #0d4169;
  animation: spin 0.7s linear infinite;
}

.txn-scan-spinner-lg {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(13, 65, 105, 0.15);
  border-radius: 50%;
  border-top-color: #0d4169;
  animation: spin 0.7s linear infinite;
}
</style>
